import type { TranslationKey } from './i18n';

// Oleada de idiomas 2026-07-25 (decisión del dueño tras el estudio de mercado):
// RU (comunidad enorme + demanda probada), KO (~36% del revenue del juego),
// ZH-TW (Taiwán/HK top-5), JA (top-3) y TR (comunidad grande y activa).
// Viven en este archivo hermano para no inflar i18n.tsx; la paridad de claves
// la garantiza i18n.test.ts. La GUÍA (/guia) sigue en los 5 idiomas originales
// (decisión: los idiomas nuevos ven la guía en inglés por ahora).
// NOTA: el juego DENTRO de BlueStacks debe seguir en inglés o español (el bot
// solo lee esos idiomas) — el hint settings.gameLanguageHint lo avisa.

export const ru: Record<TranslationKey, string> = {
  'app.account': 'Аккаунт',
  'app.configuration': 'Настройки',
  'app.configurationUnavailable': 'Настройки недоступны',
  'app.faq': 'FAQ',
  'app.faqButton': 'Часто задаваемые вопросы',
  'app.guide': 'Руководство',
  'app.guideButton': 'Открыть руководство по установке',
  'app.language': 'Язык',
  'app.license': 'Лицензия',
  'app.manageBilling': 'Управление подпиской',
  'app.subscribe': 'Подписаться',
  'app.openAccountMenu': 'Открыть меню аккаунта',
  'app.signOut': 'Выйти',
  'app.billingError': 'Не удалось открыть портал оплаты.',
  'app.billingNoStripe': 'Ваша лицензия не управляется через Stripe (доступ выдан вручную): платежей для управления нет.',
  'app.product': 'White Bot Desktop',

  'auth.title': 'White Bot',
  'auth.subtitle': 'Desktop-план · €11,99/мес · 5 дней бесплатно',
  'auth.betaSubtitle': 'Бесплатная бета',
  'auth.intro': 'Войдите, чтобы управлять ботом.',
  'auth.email': 'Email',
  'auth.placeholderEmail': 'you@email.com',
  'auth.sendLink': 'Отправить ссылку для входа',
  'auth.googleLogin': 'Войти через Google',
  'auth.checkEmail': 'Проверьте почту: мы отправили вам ссылку для входа.',
  'auth.loadingSession': 'Загрузка сессии…',

  'entitlement.checking': 'Проверка подписки…',
  'entitlement.active': 'активна',
  'entitlement.trialing': 'пробный период',
  'entitlement.past_due': 'ожидается оплата',
  'entitlement.canceled': 'отменена',
  'entitlement.inactive': 'неактивна',

  'pills.connected': 'клиент подключён',
  'pills.disconnected': 'клиент отключён',

  'dashboard.actions': 'Действия',
  'dashboard.autoBot': 'Авто-бот',
  'dashboard.collect': 'Сбор ресурсов',
  'dashboard.trainTroops': 'Обучение войск',
  'dashboard.autoHunt': 'Авто-охота',
  'dashboard.stopBot': 'Остановить бота',
  'dashboard.screenshot': 'Скриншот',
  'dashboard.mockView': 'Демонстрационный вид — клиент ещё не прислал скриншоты',
  'dashboard.marches': 'Марши',
  'dashboard.training': 'Обучение',
  'dashboard.noRecentVerification': 'Нет недавней проверки',
  'dashboard.queue': 'Очередь',
  'dashboard.state': 'Состояние',
  'dashboard.activity': 'Активность',
  'dashboard.lastReport': 'Последний отчёт',
  'dashboard.clientVersion': 'Версия клиента',
  'dashboard.never': 'никогда',
  'dashboard.disconnectedNotice': 'Клиент давно не выходил на связь. Проверьте, что он запущен на вашем ПК вместе с BlueStacks.',
  'dashboard.settingsSaved': 'Настройки сохранены.',
  'dashboard.client': 'Клиент',
  'dashboard.clientBody': 'Скачайте и установите клиент на свой ПК (Windows + BlueStacks). Он активируется вашим аккаунтом.',
  'dashboard.clientDownload': 'Скачать клиент (будет доступно в релизе)',
  'dashboard.clientDownloadReady': 'Скачать клиент (бета)',
  'dashboard.clientSmartscreen': 'Скачивается как ZIP: распакуйте и запустите установщик. Бета без подписи: если браузер или Windows предупредят, выберите «Сохранить» и «Подробнее → Выполнить в любом случае».',

  'op.workingEyebrow': 'Операция выполняется',
  'op.successEyebrow': 'Готово',
  'op.errorEyebrow': 'Нет подтверждения',
  'op.warningEyebrow': 'Внимание',
  'op.startTitle': 'Запуск: {action}',
  'op.startBody': 'Команда отправлена. Клиент на вашем ПК получит её через несколько секунд.',
  'op.stopTitle': 'Остановка бота',
  'op.stopBody': 'Команда отправлена. Бот завершит текущий шаг и остановится.',
  'op.successStartTitle': 'Бот работает',
  'op.successStartBody': 'Клиент подтвердил выполнение.',
  'op.successStopTitle': 'Бот остановлен',
  'op.successStopBody': 'Клиент подтвердил остановку.',
  'op.timeoutTitle': 'Клиент не подтвердил',
  'op.timeoutBody': 'Команда сохранена и применится, когда клиент подключится. Проверьте, что клиент запущен на вашем ПК.',
  'op.disconnectedTitle': 'Клиент отключён',
  'op.disconnectedBody': 'Ваш бот сейчас не выходит на связь. Откройте клиент на ПК (вместе с BlueStacks) и попробуйте снова. Команду всё равно можно отправить.',
  'op.sendAnyway': 'Отправить всё равно',
  'op.close': 'Закрыть',
  'op.cancel': 'Отмена',

  'settings.level': 'Уровень',
  'settings.marches': 'Марши',
  'settings.amount': 'Количество за цикл',
  'settings.type': 'Тип',
  'settings.beasts': 'Звери (10 выносливости)',
  'settings.terror': 'Полярный ужас (25 выносливости)',
  'settings.timer': 'Ожидание ралли',
  'settings.up': 'Увеличить',
  'settings.down': 'Уменьшить',
  'settings.resources.iron': 'Железо',
  'settings.resources.coal': 'Уголь',
  'settings.resources.wood': 'Дерево',
  'settings.resources.meat': 'Мясо',
  'settings.units.infantry': 'Пехота',
  'settings.units.lancer': 'Копейщики',
  'settings.units.marksman': 'Стрелки',
  'settings.autoHelp': 'Авто-помощь',
  'settings.autoHeal': 'Авто-лечение',
  'settings.autoShield': 'Авто-щит',
  'settings.tasks': 'Задачи',
  'settings.tasksEnable': 'Включить автоматические задачи',
  'settings.tasksHint': 'Ежедневные награды и задания: почта, бесплатные герои, сундук простоя и разведзадания. Выполняются автоматически.',
  'settings.taskMail': 'Почта (забрать)',
  'settings.taskHeroes': 'Бесплатные герои',
  'settings.taskIdle': 'Сундук простоя',
  'settings.taskIntel': 'Разведзадания',
  // Разведка карты (0.6.4, doc 17)
  'settings.intelMapping': 'Разведка карты',
  'settings.intelEnable': 'Включить разведку карты',
  'settings.intelHint': 'Ваши боты исследуют карту выбранного региона и пополняют сеть разведки. Каждая отсканированная ячейка приносит жетоны для оплаты поиска.',
  'settings.intelRegion': 'Регион для разведки',
  'settings.intelRegionHint': 'От 3 до 5 цифр (напр. 4347). Обычно ваш собственный регион.',
  'settings.intelCheckRegion': 'Проверить регион',
  'settings.intelChecking': 'Проверка региона…',
  'settings.intelRegionReady': 'Регион {region} уже в сети ({total} ячеек). Можно начинать разведку.',
  'settings.intelRegionSeeded': 'Регион {region} добавлен в сеть ({total} ячеек). Ваши боты могут приступать к разведке.',
  'settings.intelRegionInvalid': 'Неверный регион: укажите от 3 до 5 цифр.',
  'settings.intelRegionError': 'Не удалось проверить регион. Попробуйте ещё раз.',
  'settings.intelCellsPerPass': 'Ячеек за проход',
  'settings.intelCellsPerPassHint': 'Сколько ячеек бот сканирует за один цикл разведки, прежде чем вернуться к остальным задачам.',
  'settings.game': 'Игра',
  'settings.gameLanguage': 'Язык игры',
  'settings.gameLanguageEn': 'Английский (по умолчанию)',
  'settings.gameLanguageEs': 'Испанский',
  'settings.gameLanguageHint': 'Это язык ИГРЫ внутри BlueStacks (не этого сайта). Бот умеет читать игру только на английском или испанском: установите его в настройках игры (Settings → Language) и выберите тот же здесь.',
  'settings.cryptids': 'Сначала криптиды (события)',
  'settings.cryptidsHint': 'Если идёт событие «Бешеный криптид» и у вас есть Рог криптида, охота потратит его на криптида; без события или рогов охота идёт как обычно (рога выпадают с обычных зверей).',
  'status.hunting_cryptid': 'Поиск криптида события…',

  'subscribe.title': 'Попробуйте White Bot бесплатно 5 дней',
  'subscribe.body': 'Запустите White Bot на своём ПК (Windows + BlueStacks) и управляйте им с этого сайта.',
  'subscribe.trial': 'ПРОБНЫЙ ПЕРИОД',
  'subscribe.trialValue': '5 дней бесплатно',
  'subscribe.after': 'ПОТОМ',
  'subscribe.afterValue': '€11,99 / месяц',
  'subscribe.includes': 'ВКЛЮЧАЕТ',
  'subscribe.includesValue': 'Сбор · Войска · Охота · Лечение · Щит · Помощь альянса · Ежедневные задачи',
  'subscribe.cancel': 'ОТМЕНА',
  'subscribe.cancelValue': 'В любой момент',
  'subscribe.cta': 'Начать пробный период (5 дней)',
  'subscribe.ctaOpening': 'Открываем оплату…',
  'subscribe.cardNote': 'Карта для пробного периода не нужна. Вы платите, только если решите подписаться после его окончания.',
  'subscribe.trialCta': 'Начать 5 дней бесплатно — без карты',
  'subscribe.trialStarting': 'Активируем пробный период…',
  'subscribe.trialError': 'Не удалось активировать пробный период. Попробуйте ещё раз.',
  'subscribe.trialUsed': 'Пробный период на этом аккаунте уже использован.',
  'subscribe.payCta': 'Подписаться — €11,99/мес',
  'subscribe.endedTitle': 'Ваш доступ закончился',
  'subscribe.endedBody': 'Пробный период или подписка закончились. Подпишитесь, чтобы продолжить пользоваться White Bot на своём ПК — настройки сохранены.',
  'subscribe.checkoutError': 'Ошибка при запуске оплаты',
  'subscribe.hostedNote': 'Пользуетесь облачной версией (работает на наших серверах)? Это другой продукт:',
  'subscribe.hostedLink': 'перейти на whitebot.app',

  'beta.banner': 'Бесплатная бета',
  'subscribe.betaTitle': 'White Bot — бесплатно на время беты',
  'subscribe.betaTrial': 'БЕТА',
  'subscribe.betaTrialValue': 'Бесплатно до 15.08.2026',
  'subscribe.betaTrialCta': 'Начать бесплатную бету',
  'subscribe.betaCardNote': 'Карта не нужна. White Bot бесплатен на время беты, до 15 августа 2026.',
  'subscribe.betaEndedNote': 'Идёт бесплатная бета. Если у вас нет доступа, напишите нам в чат поддержки.',

  'tutorial.title': 'Первые шаги',
  'tutorial.intro': 'Три шага, чтобы бот заработал на вашем ПК под управлением этого сайта.',
  'tutorial.step1Title': '1. Установите клиент',
  'tutorial.step1Body': 'Скачайте клиент и установите его на ПК вместе с BlueStacks. Руководство проведёт вас по шагам.',
  'tutorial.step2Title': '2. Активируйте его по email',
  'tutorial.step2Body': 'Откройте клиент и введите свой email. Когда он подключится, здесь появится «клиент подключён».',
  'tutorial.step3Title': '3. Управляйте ботом отсюда',
  'tutorial.step3Body': 'Выберите модули и настройки, нажмите действие и следите за скриншотом и состоянием на этой панели.',
  'tutorial.dontShowAgain': 'Больше не показывать',
  'tutorial.notNow': 'Не сейчас',
  'tutorial.gotIt': 'Понятно',

  'pills.license': 'лицензия: {label}',

  'dashboard.refreshCapture': 'Обновить скриншот',
  'dashboard.refreshCapturePending': 'Делаем снимок…',
  'dashboard.refreshCaptureTimeout': 'Клиент не ответил на запрос скриншота. Проверьте, что он открыт на вашем ПК.',

  'state.idle': 'ожидание',
  'state.running': 'работает',
  'state.waiting': 'ждёт',
  'state.starting': 'запускается',
  'state.verifying': 'проверяет',
  'state.training': 'обучает',
  'state.collecting': 'собирает',
  'state.hunting': 'охотится',
  'state.helping': 'помогает',
  'state.healing': 'лечит',
  'state.recovering': 'восстанавливается',
  'state.reconnecting': 'переподключается',
  'state.shielded': 'щит активен',
  'state.error': 'ошибка',

  'status.no_client': 'Клиент не подключён.',
  'status.idle': 'В режиме ожидания (остановлен с сайта).',
  'status.running': 'Работает: {modules}',
  'status.running_none': 'Работает (нет активных модулей).',
  'status.shielded': 'Авто-щит включил защиту: бот остановлен. Нажмите «Стоп», затем снова «Старт», чтобы продолжить.',
  'shieldAlarm.eyebrow': 'Авто-щит',
  'shieldAlarm.title': 'Мы защитили вас от атаки',
  'shieldAlarm.body': 'Мы обнаружили атаку на {name} и автоматически включили щит. Ваши войска отозваны, а колония защищена. Бот остановлен в целях безопасности — нажмите «Старт», чтобы продолжить.',
  'shieldAlarm.time': 'Время атаки',
  'shieldAlarm.close': 'Понятно',
  'status.starting': 'Проверка при запуске: очищаем экран и проверяем колонию…',
  'status.waiting': 'Дел нет. Следующая проверка через {time}.',
  'status.backoff_wait': 'Идёт восстановление; повтор через {time}.',
  'status.verifying_training': 'Проверка очередей обучения…',
  'status.verifying_marches': 'Проверка очередей маршей…',
  'status.verifying_hunt': 'Проверка охотничьих маршей…',
  'status.training_collect': 'Забираем обученные войска: {units}',
  'langWarn.eyebrow': 'Язык игры',
  'langWarn.title': 'Переключите игру на английский',
  'langWarn.body': 'White Bot не может читать вашу игру: язык не поддерживается. В Whiteout Survival откройте Настройки → Language и выберите English. Бот продолжит работу сам после смены языка.',
  'langWarn.close': 'Понятно',
  'fleet.title': 'Мои боты',
  'fleet.counter': '{n}/{max} ботов',
  'fleet.startAll': 'Запустить все',
  'fleet.stopAll': 'Остановить все',
  'fleet.delete': 'Удалить',
  'fleet.deleteConfirmTitle': 'Удалить {name}?',
  'fleet.deleteConfirmBody': 'Освобождает место в лимите аккаунта. Если клиент этого бота ещё открыт на ПК, он появится снова при следующем отчёте.',
  'fleet.deleteConfirm': 'Удалить бота',
  'fleet.deleteCancel': 'Отмена',
  'fleet.back': 'Все боты',
  'fleet.empty': 'Ботов пока нет. Откройте White Bot Client на ПК (одна консоль на инстанс BlueStacks) — они появятся здесь сами.',
  'fleet.defaultName': 'Бот',
  'fleet.lastReport': 'Последний отчёт',
  'status.unsupported_language': 'Язык игры не поддерживается — переключите на английский',
  'status.language_autofix': 'Язык не поддерживается: игра автоматически переключается на английский…',
  'status.dailies': 'Забираем ежедневные награды…',
  'status.intel_missions': 'Разведывательные задания…',
  'status.intel_map_scanning': 'Разведка: отсканировано {cells} ячеек (+{tokens} жетонов)',
  'status.intel_map_region_done': 'Разведка: регион актуален',
  'status.intel_map_detector_missing': 'Разведка: детектор недоступен',
  'status.intel_map_region_missing': 'Разведка: укажите регион в настройках',
  'state.intel': 'Разведка',
  'state.dailies': 'Ежедневные награды',
  'status.language_fixed': 'Язык переключён на английский; ожидание перезапуска игры…',
  'state.fixing_language': 'Смена языка',
  'state.blocked_language': 'Язык не поддерживается',
  'status.training_units': 'Обучаем войска: {units} ({percent}%)',
  'status.collecting_send': 'Отправляем марш за ресурсами: {resource} (уровень {level})',
  'status.hunting_send': 'Отправляем атаку на охоту: {type}, уровень {level}',
  'status.helping': 'Проверка авто-помощи альянсу…',
  'status.healing': 'Проверка авто-лечения…',
  'status.recovering_attempt': 'Восстановление ({attempt}/{max}); повтор через {time}…',
  'status.recovered_ui': 'Экран восстановлен после сбоя ({task}). Продолжаем…',
  'status.relaunching': 'Перезапуск BlueStacks/игры после повторных сбоев…',
  'status.relaunched': 'Игра перезапущена после сбоя. Продолжим через {time}.',
  'status.hand_guide': 'Обнаружена рука-подсказка: нажимаем, куда она указывает…',
  'status.reconnecting': 'Сессия открыта на другом устройстве: нажимаем «Переподключиться»…',
  'status.backoff_init_error': 'Ошибка инициализации ({detail}). Автоповтор через {time}.',
  'status.backoff_no_adb': 'Нет соединения с BlueStacks (ADB). Проверьте, что BlueStacks открыт. Повтор через {time}.',
  'status.backoff_failure': 'Повторяющийся сбой ({task}). Автоповтор через {time}.',
  'status.backoff_blocked': 'Экран заблокирован ({kind}). Автоповтор через {time}.',

  'statusTask.verify_training': 'проверка очереди обучения',
  'statusTask.collect_completed': 'сбор обученных войск',
  'statusTask.train_flow': 'процесс обучения',
  'statusTask.return_after_training': 'возврат в колонию после обучения',
  'statusTask.verify_marches': 'проверка маршей',
  'statusTask.collect_flow': 'процесс сбора',
  'statusTask.hunt_capture': 'снимок статуса охоты',
  'statusTask.verify_hunt': 'проверка охотничьих маршей',
  'statusTask.hunt_vigor': 'чтение выносливости',
  'statusTask.hunt_flow': 'процесс охоты',
  'statusTask.auto_heal': 'авто-лечение',
  'statusTask.startup_return': 'возврат в колонию при запуске',
  'statusTask.startup_screen': 'нераспознанный экран при запуске',
  'statusTask.unexpected': 'непредвиденная ошибка',

  'intelligence.title': 'Разведка',
  'intelligence.intro': 'Ищите игроков и альянсы по данным сети White Bot. {limit} запросов в день.',
  'intelligence.region': 'Регион',
  'intelligence.regionPlaceholder': 'Регион (например, 4347)',
  'intelligence.searchPlayer': 'Поиск игрока или альянса',
  'intelligence.searchPlaceholder': 'Игрок или альянс (пусто = весь регион)',
  'intelligence.regionSearchTitle': 'Весь регион {region}',
  'intelligence.errorUnknownRegion': 'Этого региона ещё нет в сети (проверьте номер).',
  'intelligence.quotaRemainingValue': '{remaining} из {limit}',
  'intelligence.request': 'Искать',
  'intelligence.requesting': 'Ищем…',
  'intelligence.quotaRemaining': 'Осталось запросов на сегодня',
  'intelligence.minChars': 'Введите минимум 3 символа или оставьте пустым, чтобы получить весь регион.',
  'intelligence.regionRequired': 'Укажите регион для поиска (например, 4347).',
  'intelligence.loading': 'Загрузка запросов…',
  'intelligence.empty': 'Запросов пока нет.',
  'intelligence.delete': 'Удалить запрос',
  'intelligence.power': 'Мощь',
  'intelligence.coordinates': 'Координаты',
  'intelligence.notFound': 'Совпадений нет.',
  'intelligence.noResult': 'Результат ожидается (в этом регионе пока нет данных).',
  'intelligence.statusPending': 'В очереди',
  'intelligence.statusProcessing': 'Идёт поиск',
  'intelligence.statusCompleted': 'Готово',
  'intelligence.statusNotFound': 'Не найдено',
  'intelligence.statusFailed': 'Не удалось получить результат',
  'intelligence.errorQuota': 'Вы использовали все запросы на сегодня. Возвращайтесь завтра.',
  'intelligence.errorPending': 'Этот запрос уже выполняется.',
  'intelligence.errorNoRegion': 'Укажите корректный регион для поиска.',
  'intelligence.errorGeneric': 'Не удалось выполнить поиск. Попробуйте ещё раз.',
  'intelligence.search': 'Искать',
  'intelligence.resultsFound': '{count} результатов',
  'intelligence.showMore': 'Показать ещё {count}',
  'intelligence.showLess': 'Свернуть',
  'intelligence.sortResults': 'Сортировка',
  'intelligence.sortPower': 'Мощь',
  'intelligence.sortName': 'Имя',
  'intelligence.lastSeen': 'Замечен',
  'intelligence.deleteConfirm': 'Убрать «{name}» с панели? Запрос всё равно учитывается в дневном лимите.',
  // Экономика жетонов + прогресс разведки (0.6.4, doc 17)
  'intelligence.tokensChip': 'Жетоны: {n}',
  'intelligence.freeChip': '{n} бесплатно сегодня',
  'intelligence.freeTodayLabel': 'Бесплатный поиск на сегодня',
  'intelligence.tokensBalance': 'Баланс жетонов',
  'intelligence.costsLine': 'Стоимость в жетонах: поиск {search} · весь регион {region}',
  'intelligence.noTokensCta': 'Бесплатный поиск использован, жетонов нет: включите разведку карты в настройках — ваши боты будут зарабатывать жетоны, сканируя карту.',
  'intelligence.errorTokens': 'Недостаточно жетонов для этого поиска. Включите разведку карты, чтобы заработать ещё.',
  'intelligence.mappingTitle': 'Прогресс разведки',
  'intelligence.mappingCells': '{scanned} из {total} ячеек',
  'intelligence.mappingToday': 'Отсканировано сегодня вашими ботами',
  'intelligence.mappingEarnedToday': 'Жетонов заработано сегодня',
  'shieldWatch.toggle': 'Следить за щитом игрока (этот бот перестаёт картировать)',
  'shieldWatch.title': 'Shield Monitor',
  'shieldWatch.historyTitle': 'История наблюдения',
  'activity.title': 'Активность разведки',
  'activity.showAll': 'Показать все ({count})',
  'activity.showLess': 'Свернуть',
  'activity.protected': 'Атака обнаружена: мы защитили вас щитом',
  'activity.attackHalted': 'Атака обнаружена: щит НЕ подтверждён',
  'shieldWatch.captureOpen': 'Посмотреть снимок этого момента',
  'shieldWatch.captureLoading': 'Загрузка снимка…',
  'shieldWatch.captureAlt': 'Снимок момента, когда бот принял решение',
  'shieldWatch.captureGone': 'Этого снимка больше нет: хранятся только последние 5 для каждого бота.',
  'shieldWatch.captureClose': 'Закрыть',
  'shieldWatch.help': 'Введите координаты замка для наблюдения. Бот будет периодически проверять, есть ли ещё щит, и пришлёт письмо, когда он спадёт.',
  'shieldWatch.interval': 'Каждые',
  'shieldWatch.region': 'Регион',
  'shieldWatch.needCoords': 'Укажите координаты X и Y игрока для наблюдения.',
  'shieldWatch.idleNote': 'Проверки идут в свободные промежутки бота; при загруженной ферме они могут быть реже.',
  'shieldWatch.stateShielded': 'У цели ВСЁ ЕЩЁ есть щит',
  'shieldWatch.stateConfirming': 'Щита нет: подтверждаем…',
  'shieldWatch.stateDown': 'ЩИТ СПАЛ!',
  'shieldWatch.stateMoved': 'Цели больше нет по этим координатам',
  'shieldWatch.stateNoDetector': 'Наблюдение невозможно: детектор недоступен',
  'intelligence.mappingNoRegion': 'Выберите и проверьте регион в Настройки → Разведка карты, чтобы видеть прогресс.',

  'support.title': 'Поддержка',
  'support.subtitle': 'Служба поддержки — отвечаем прямо здесь.',
  'support.open': 'Открыть чат поддержки',
  'support.close': 'Закрыть чат поддержки',
  'support.empty': 'Нужна помощь? Опишите проблему (можно приложить скриншот), и мы ответим в этом чате.',
  'support.placeholder': 'Введите сообщение…',
  'support.send': 'Отправить',
  'support.sending': 'Отправляем…',
  'support.attach': 'Приложить скриншот',
  'support.attachRemove': 'Убрать изображение',
  'support.attachTooBig': 'Изображение больше 5 МБ.',
  'support.attachNotImage': 'Можно прикладывать только изображения.',
  'support.imageAlt': 'Приложенный скриншот',
  'support.you': 'Вы',
  'support.agent': 'Поддержка',
  'support.sendError': 'Не удалось отправить сообщение. Попробуйте ещё раз.',
  'support.loading': 'Загрузка переписки…',
  'support.unreadLabel': '{count} новых сообщений поддержки'
};

export const ko: Record<TranslationKey, string> = {
  'app.account': '계정',
  'app.configuration': '설정',
  'app.configurationUnavailable': '설정을 사용할 수 없습니다',
  'app.faq': 'FAQ',
  'app.faqButton': '자주 묻는 질문',
  'app.guide': '가이드',
  'app.guideButton': '설치 가이드 보기',
  'app.language': '언어',
  'app.license': '라이선스',
  'app.manageBilling': '구독 관리',
  'app.subscribe': '구독하기',
  'app.openAccountMenu': '계정 메뉴 열기',
  'app.signOut': '로그아웃',
  'app.billingError': '결제 포털을 열 수 없습니다.',
  'app.billingNoStripe': '라이선스가 Stripe로 관리되지 않습니다(수동으로 부여된 이용 권한): 관리할 결제가 없습니다.',
  'app.product': 'White Bot Desktop',

  'auth.title': 'White Bot',
  'auth.subtitle': 'Desktop 플랜 · 월 €11.99 · 5일 무료 체험',
  'auth.betaSubtitle': '무료 베타',
  'auth.intro': '로그인하여 봇을 관리하세요.',
  'auth.email': '이메일',
  'auth.placeholderEmail': 'you@email.com',
  'auth.sendLink': '접속 링크 보내기',
  'auth.googleLogin': 'Google로 로그인',
  'auth.checkEmail': '이메일을 확인하세요: 접속 링크를 보냈습니다.',
  'auth.loadingSession': '세션 불러오는 중…',

  'entitlement.checking': '구독 확인 중…',
  'entitlement.active': '활성',
  'entitlement.trialing': '체험 중',
  'entitlement.past_due': '결제 대기',
  'entitlement.canceled': '취소됨',
  'entitlement.inactive': '비활성',

  'pills.connected': '클라이언트 연결됨',
  'pills.disconnected': '클라이언트 연결 끊김',

  'dashboard.actions': '동작',
  'dashboard.autoBot': '오토 봇',
  'dashboard.collect': '자원 채집',
  'dashboard.trainTroops': '병력 훈련',
  'dashboard.autoHunt': '자동 사냥',
  'dashboard.stopBot': '봇 정지',
  'dashboard.screenshot': '스크린샷',
  'dashboard.mockView': '시뮬레이션 화면 — 클라이언트가 아직 캡처를 보내지 않았습니다',
  'dashboard.marches': '행군',
  'dashboard.training': '훈련',
  'dashboard.noRecentVerification': '최근 확인 없음',
  'dashboard.queue': '대기열',
  'dashboard.state': '상태',
  'dashboard.activity': '활동',
  'dashboard.lastReport': '마지막 보고',
  'dashboard.clientVersion': '클라이언트 버전',
  'dashboard.never': '없음',
  'dashboard.disconnectedNotice': '클라이언트가 한동안 보고하지 않았습니다. PC에서 BlueStacks와 함께 실행 중인지 확인하세요.',
  'dashboard.settingsSaved': '설정이 저장되었습니다.',
  'dashboard.client': '클라이언트',
  'dashboard.clientBody': 'PC에 클라이언트를 다운로드하여 설치하세요(Windows + BlueStacks). 계정으로 활성화됩니다.',
  'dashboard.clientDownload': '클라이언트 다운로드(정식 출시 시 제공)',
  'dashboard.clientDownloadReady': '클라이언트 다운로드(베타)',
  'dashboard.clientSmartscreen': 'ZIP으로 다운로드됩니다: 압축을 풀고 설치 프로그램을 실행하세요. 서명되지 않은 베타: 브라우저나 Windows가 경고하면 "유지"와 "추가 정보 → 실행"을 선택하세요.',

  'op.workingEyebrow': '작업 진행 중',
  'op.successEyebrow': '완료',
  'op.errorEyebrow': '확인 없음',
  'op.warningEyebrow': '주의',
  'op.startTitle': '{action} 시작 중',
  'op.startBody': '명령을 보냈습니다. PC의 클라이언트가 몇 초 안에 수신합니다.',
  'op.stopTitle': '봇 정지 중',
  'op.stopBody': '명령을 보냈습니다. 봇이 현재 단계를 마치고 정지합니다.',
  'op.successStartTitle': '봇 실행 중',
  'op.successStartBody': '클라이언트가 실행을 확인했습니다.',
  'op.successStopTitle': '봇 정지됨',
  'op.successStopBody': '클라이언트가 정지를 확인했습니다.',
  'op.timeoutTitle': '클라이언트가 확인하지 않았습니다',
  'op.timeoutBody': '명령은 저장되었으며 클라이언트가 연결되면 적용됩니다. PC에서 클라이언트가 실행 중인지 확인하세요.',
  'op.disconnectedTitle': '클라이언트 연결 끊김',
  'op.disconnectedBody': '봇이 지금 보고하지 않고 있습니다. PC에서 클라이언트를 (BlueStacks와 함께) 열고 다시 시도하세요. 명령은 지금도 보낼 수 있습니다.',
  'op.sendAnyway': '그래도 보내기',
  'op.close': '닫기',
  'op.cancel': '취소',

  'settings.level': '레벨',
  'settings.marches': '행군',
  'settings.amount': '1회 훈련량',
  'settings.type': '유형',
  'settings.beasts': '야수 (기력 10)',
  'settings.terror': '극지의 공포 (기력 25)',
  'settings.timer': '집결 대기',
  'settings.up': '늘리기',
  'settings.down': '줄이기',
  'settings.resources.iron': '철',
  'settings.resources.coal': '석탄',
  'settings.resources.wood': '목재',
  'settings.resources.meat': '고기',
  'settings.units.infantry': '보병',
  'settings.units.lancer': '창병',
  'settings.units.marksman': '사수',
  'settings.autoHelp': '자동 지원',
  'settings.autoHeal': '자동 치료',
  'settings.autoShield': '자동 보호막',
  'settings.tasks': '작업',
  'settings.tasksEnable': '자동 작업 활성화',
  'settings.tasksHint': '일일 보상과 임무: 우편, 무료 영웅, 유휴 상자, 정보 임무. 일정에 따라 자동 수행.',
  'settings.taskMail': '우편 (수령)',
  'settings.taskHeroes': '무료 영웅',
  'settings.taskIdle': '유휴 상자',
  'settings.taskIntel': '정보 임무',
  // 정보 매핑 (0.6.4, doc 17)
  'settings.intelMapping': '정보 매핑',
  'settings.intelEnable': '정보 매핑 활성화',
  'settings.intelHint': '봇이 선택한 지역의 지도를 탐색하며 정보 네트워크에 데이터를 제공합니다. 스캔한 칸마다 검색에 쓸 수 있는 토큰을 얻습니다.',
  'settings.intelRegion': '매핑할 지역',
  'settings.intelRegionHint': '3~5자리 숫자 (예: 4347). 보통 자신의 지역입니다.',
  'settings.intelCheckRegion': '지역 확인',
  'settings.intelChecking': '지역 확인 중…',
  'settings.intelRegionReady': '{region} 지역은 이미 네트워크에 있습니다 ({total}칸). 바로 매핑할 수 있습니다.',
  'settings.intelRegionSeeded': '{region} 지역을 네트워크에 추가했습니다 ({total}칸). 이제 봇이 매핑을 시작할 수 있습니다.',
  'settings.intelRegionInvalid': '유효하지 않은 지역입니다. 3~5자리 숫자를 입력하세요.',
  'settings.intelRegionError': '지역을 확인할 수 없습니다. 다시 시도하세요.',
  'settings.intelCellsPerPass': '1회당 스캔 칸 수',
  'settings.intelCellsPerPassHint': '봇이 다른 작업으로 돌아가기 전에 매핑 1회당 몇 칸을 스캔할지 정합니다.',
  'settings.game': '게임',
  'settings.gameLanguage': '게임 언어',
  'settings.gameLanguageEn': '영어 (기본)',
  'settings.gameLanguageEs': '스페인어',
  'settings.gameLanguageHint': 'BlueStacks 안 게임의 언어입니다(이 웹사이트의 언어가 아님). 봇은 영어 또는 스페인어로만 게임을 읽을 수 있습니다: 게임 설정 → 언어에서 설정하고 여기서 같은 언어를 선택하세요.',
  'settings.cryptids': '크립티드 우선 (이벤트)',
  'settings.cryptidsHint': '광포한 크립티드 이벤트가 진행 중이고 크립티드 뿔이 있으면 사냥이 크립티드에 사용합니다. 이벤트나 뿔이 없으면 평소처럼 사냥합니다(야수를 잡으면 뿔이 나옵니다).',
  'status.hunting_cryptid': '이벤트 크립티드 찾는 중…',

  'subscribe.title': 'White Bot 5일 무료 체험',
  'subscribe.body': '자신의 PC에서 White Bot을 실행하고(Windows + BlueStacks) 이 웹에서 제어하세요.',
  'subscribe.trial': '체험',
  'subscribe.trialValue': '5일 무료',
  'subscribe.after': '이후',
  'subscribe.afterValue': '월 €11.99',
  'subscribe.includes': '포함',
  'subscribe.includesValue': '채집 · 병력 · 사냥 · 치료 · 보호막 · 연맹 도움 · 일일 작업',
  'subscribe.cancel': '해지',
  'subscribe.cancelValue': '언제든지',
  'subscribe.cta': '무료 체험 시작 (5일)',
  'subscribe.ctaOpening': '결제 여는 중…',
  'subscribe.cardNote': '체험에는 카드가 필요 없습니다. 체험이 끝나고 구독하기로 결정할 때만 결제합니다.',
  'subscribe.trialCta': '5일 무료 체험 시작 — 카드 불필요',
  'subscribe.trialStarting': '체험 활성화 중…',
  'subscribe.trialError': '체험을 활성화할 수 없습니다. 다시 시도하세요.',
  'subscribe.trialUsed': '이 계정에서는 이미 무료 체험을 사용했습니다.',
  'subscribe.payCta': '구독 — 월 €11.99',
  'subscribe.endedTitle': '이용 기간이 끝났습니다',
  'subscribe.endedBody': '체험 또는 구독이 끝났습니다. 구독하면 PC에서 White Bot을 계속 사용할 수 있습니다 — 설정은 유지됩니다.',
  'subscribe.checkoutError': '결제 시작 오류',
  'subscribe.hostedNote': '호스티드 서비스(저희 서버에서 실행)를 쓰시나요? 다른 제품입니다:',
  'subscribe.hostedLink': 'whitebot.app으로 이동',

  'beta.banner': '무료 베타',
  'subscribe.betaTitle': '베타 기간 동안 무료인 White Bot',
  'subscribe.betaTrial': '베타',
  'subscribe.betaTrialValue': '2026년 8월 15일까지 무료',
  'subscribe.betaTrialCta': '무료 베타 시작',
  'subscribe.betaCardNote': '카드가 필요 없습니다. White Bot은 베타 기간인 2026년 8월 15일까지 무료입니다.',
  'subscribe.betaEndedNote': '무료 베타 중입니다. 이용할 수 없다면 지원 채팅으로 문의하세요.',

  'tutorial.title': '시작하기',
  'tutorial.intro': 'PC에서 봇을 실행하고 여기서 제어하기까지 세 단계.',
  'tutorial.step1Title': '1. 클라이언트 설치',
  'tutorial.step1Body': '클라이언트를 다운로드하여 BlueStacks와 함께 PC에 설치하세요. 가이드가 단계별로 안내합니다.',
  'tutorial.step2Title': '2. 이메일로 활성화',
  'tutorial.step2Body': '클라이언트를 열고 이메일을 입력하세요. 연결되면 여기에 "클라이언트 연결됨"이 표시됩니다.',
  'tutorial.step3Title': '3. 여기서 봇 제어',
  'tutorial.step3Body': '모듈과 설정을 고르고 동작을 누른 뒤, 이 패널에서 캡처와 상태를 확인하세요.',
  'tutorial.dontShowAgain': '다시 표시하지 않기',
  'tutorial.notNow': '나중에',
  'tutorial.gotIt': '확인',

  'pills.license': '라이선스: {label}',

  'dashboard.refreshCapture': '캡처 새로고침',
  'dashboard.refreshCapturePending': '캡처 중…',
  'dashboard.refreshCaptureTimeout': '클라이언트가 캡처 요청에 응답하지 않았습니다. PC에서 열려 있는지 확인하세요.',

  'state.idle': '대기',
  'state.running': '실행 중',
  'state.waiting': '대기 중',
  'state.starting': '시작 중',
  'state.verifying': '확인 중',
  'state.training': '훈련 중',
  'state.collecting': '채집 중',
  'state.hunting': '사냥 중',
  'state.helping': '지원 중',
  'state.healing': '치료 중',
  'state.recovering': '복구 중',
  'state.reconnecting': '재연결 중',
  'state.shielded': '보호막 활성',
  'state.error': '오류',

  'status.no_client': '연결된 클라이언트가 없습니다.',
  'status.idle': '대기 중(웹에서 정지됨).',
  'status.running': '실행 중: {modules}',
  'status.running_none': '실행 중(활성 모듈 없음).',
  'status.shielded': '자동 보호막이 보호를 활성화하여 봇이 정지되었습니다. 계속하려면 정지 후 다시 시작을 누르세요.',
  'shieldAlarm.eyebrow': '자동 보호막',
  'shieldAlarm.title': '공격으로부터 보호했습니다',
  'shieldAlarm.body': '{name}에 대한 공격을 감지하여 자동으로 보호막을 활성화했습니다. 부대는 철수했고 거점은 안전합니다. 안전을 위해 봇이 정지되었습니다. 계속하려면 시작을 누르세요.',
  'shieldAlarm.time': '공격 시각',
  'shieldAlarm.close': '확인',
  'status.starting': '시작 점검: 화면을 정리하고 도시를 확인하는 중…',
  'status.waiting': '할 일이 없습니다. 다음 확인까지 {time}.',
  'status.backoff_wait': '복구 진행 중; {time} 후 재시도.',
  'status.verifying_training': '훈련 대기열 확인 중…',
  'status.verifying_marches': '행군 대기열 확인 중…',
  'status.verifying_hunt': '사냥 행군 확인 중…',
  'status.training_collect': '완료된 병력 수령 중: {units}',
  'langWarn.eyebrow': '게임 언어',
  'langWarn.title': '게임을 영어로 설정하세요',
  'langWarn.body': 'White Bot이 게임을 읽을 수 없습니다: 지원되지 않는 언어입니다. Whiteout Survival에서 설정 → Language에서 English를 선택하세요. 변경하면 봇이 자동으로 다시 시작됩니다.',
  'langWarn.close': '확인',
  'fleet.title': '내 봇',
  'fleet.counter': '{n}/{max} 봇',
  'fleet.startAll': '모두 시작',
  'fleet.stopAll': '모두 중지',
  'fleet.delete': '삭제',
  'fleet.deleteConfirmTitle': '{name}을(를) 삭제할까요?',
  'fleet.deleteConfirmBody': '계정 한도의 자리가 하나 비워집니다. 해당 봇의 클라이언트가 PC에서 아직 실행 중이면 다음 보고 시 다시 나타납니다.',
  'fleet.deleteConfirm': '봇 삭제',
  'fleet.deleteCancel': '취소',
  'fleet.back': '모든 봇',
  'fleet.empty': '아직 봇이 없습니다. PC에서 White Bot Client를 여세요(BlueStacks 인스턴스당 콘솔 1개). 자동으로 여기에 나타납니다.',
  'fleet.defaultName': '봇',
  'fleet.lastReport': '마지막 보고',
  'status.unsupported_language': '게임 언어 미지원 — 영어로 변경하세요',
  'status.language_autofix': '지원되지 않는 언어: 게임을 자동으로 영어로 전환하는 중…',
  'status.dailies': '일일 보상 수령 중…',
  'status.intel_missions': '정보 임무 수행 중…',
  'status.intel_map_scanning': '정보 매핑: {cells}칸 스캔 (+{tokens} 토큰)',
  'status.intel_map_region_done': '정보 매핑: 지역이 최신 상태입니다',
  'status.intel_map_detector_missing': '정보 매핑: 감지기를 사용할 수 없습니다',
  'status.intel_map_region_missing': '정보 매핑: 설정에서 지역을 선택하세요',
  'state.intel': '정보',
  'state.dailies': '일일 보상',
  'status.language_fixed': '영어로 전환됨; 게임 재시작 대기 중…',
  'state.fixing_language': '언어 변경 중',
  'state.blocked_language': '지원되지 않는 언어',
  'status.training_units': '병력 훈련 중: {units} ({percent}%)',
  'status.collecting_send': '채집 행군 보내는 중: {resource} (레벨 {level})',
  'status.hunting_send': '사냥 공격 보내는 중: {type} 레벨 {level}',
  'status.helping': '연맹 자동 지원 확인 중…',
  'status.healing': '자동 치료 확인 중…',
  'status.recovering_attempt': '복구 중 ({attempt}/{max}); {time} 후 재시도…',
  'status.recovered_ui': '오류({task}) 후 화면이 복구되었습니다. 계속합니다…',
  'status.relaunching': '반복 오류로 BlueStacks/게임 재시작 중…',
  'status.relaunched': '오류 후 게임을 재시작했습니다. {time} 후 재개합니다.',
  'status.hand_guide': '튜토리얼 손이 감지되어 가리키는 곳을 누릅니다…',
  'status.reconnecting': '다른 기기에서 세션이 열렸습니다: 재연결을 누르는 중…',
  'status.backoff_init_error': '초기화 오류({detail}). {time} 후 자동 재시도.',
  'status.backoff_no_adb': 'BlueStacks(ADB)와 연결할 수 없습니다. BlueStacks가 열려 있는지 확인하세요. {time} 후 재시도.',
  'status.backoff_failure': '반복 오류({task}). {time} 후 자동 재시도.',
  'status.backoff_blocked': '화면이 차단됨({kind}). {time} 후 자동 재시도.',

  'statusTask.verify_training': '훈련 대기열 확인',
  'statusTask.collect_completed': '완료된 병력 수령',
  'statusTask.train_flow': '훈련 절차',
  'statusTask.return_after_training': '훈련 후 도시 복귀',
  'statusTask.verify_marches': '행군 확인',
  'statusTask.collect_flow': '채집 절차',
  'statusTask.hunt_capture': '사냥 상태 캡처',
  'statusTask.verify_hunt': '사냥 행군 확인',
  'statusTask.hunt_vigor': '기력 읽기',
  'statusTask.hunt_flow': '사냥 절차',
  'statusTask.auto_heal': '자동 치료',
  'statusTask.startup_return': '시작 시 도시 복귀',
  'statusTask.startup_screen': '시작 시 인식되지 않은 화면',
  'statusTask.unexpected': '예기치 않은 오류',

  'intelligence.title': '정보',
  'intelligence.intro': 'White Bot 네트워크가 수집한 플레이어와 연맹을 검색하세요. 하루 {limit}회.',
  'intelligence.region': '지역',
  'intelligence.regionPlaceholder': '지역 (예: 4347)',
  'intelligence.searchPlayer': '플레이어 또는 연맹 검색',
  'intelligence.searchPlaceholder': '플레이어 또는 연맹 (비우면 지역 전체)',
  'intelligence.regionSearchTitle': '{region} 지역 전체',
  'intelligence.errorUnknownRegion': '해당 지역은 아직 네트워크에 없습니다(번호를 확인하세요).',
  'intelligence.quotaRemainingValue': '{limit}회 중 {remaining}회',
  'intelligence.request': '검색',
  'intelligence.requesting': '검색 중…',
  'intelligence.quotaRemaining': '오늘 남은 검색',
  'intelligence.minChars': '3자 이상 입력하거나, 비워 두면 지역 전체를 조회합니다.',
  'intelligence.regionRequired': '검색할 지역을 입력하세요(예: 4347).',
  'intelligence.loading': '검색 기록 불러오는 중…',
  'intelligence.empty': '아직 검색이 없습니다.',
  'intelligence.delete': '검색 삭제',
  'intelligence.power': '전투력',
  'intelligence.coordinates': '좌표',
  'intelligence.notFound': '일치하는 결과가 없습니다.',
  'intelligence.noResult': '결과 대기 중(해당 지역에 아직 데이터가 없습니다).',
  'intelligence.statusPending': '대기열',
  'intelligence.statusProcessing': '검색 중',
  'intelligence.statusCompleted': '완료',
  'intelligence.statusNotFound': '찾을 수 없음',
  'intelligence.statusFailed': '결과를 가져올 수 없습니다',
  'intelligence.errorQuota': '오늘의 검색을 모두 사용했습니다. 내일 다시 오세요.',
  'intelligence.errorPending': '해당 검색은 이미 진행 중입니다.',
  'intelligence.errorNoRegion': '유효한 지역을 입력하세요.',
  'intelligence.errorGeneric': '검색을 완료할 수 없습니다. 다시 시도하세요.',
  'intelligence.search': '검색',
  'intelligence.resultsFound': '결과 {count}건',
  'intelligence.showMore': '{count}건 더 보기',
  'intelligence.showLess': '접기',
  'intelligence.sortResults': '정렬',
  'intelligence.sortPower': '전투력',
  'intelligence.sortName': '이름',
  'intelligence.lastSeen': '확인',
  'intelligence.deleteConfirm': '"{name}"을(를) 패널에서 제거할까요? 검색은 일일 한도에 계속 포함됩니다.',
  // 토큰 경제 + 매핑 진행률 (0.6.4, doc 17)
  'intelligence.tokensChip': '토큰 {n}개',
  'intelligence.freeChip': '오늘 무료 {n}회',
  'intelligence.freeTodayLabel': '오늘의 무료 검색',
  'intelligence.tokensBalance': '토큰 잔액',
  'intelligence.costsLine': '토큰 비용: 검색 {search} · 지역 전체 {region}',
  'intelligence.noTokensCta': '무료 검색과 토큰이 모두 소진되었습니다. 설정에서 정보 매핑을 활성화하면 봇이 지도를 스캔하며 토큰을 얻습니다.',
  'intelligence.errorTokens': '이 검색에 필요한 토큰이 부족합니다. 매핑을 활성화해 토큰을 모으세요.',
  'intelligence.mappingTitle': '매핑 진행률',
  'intelligence.mappingCells': '{total}칸 중 {scanned}칸',
  'intelligence.mappingToday': '오늘 내 봇이 스캔한 칸',
  'intelligence.mappingEarnedToday': '오늘 획득한 토큰',
  'shieldWatch.toggle': '플레이어의 보호막 감시 (이 봇은 매핑을 중단합니다)',
  'shieldWatch.title': 'Shield Monitor',
  'shieldWatch.historyTitle': '감시 기록',
  'activity.title': '정보 활동',
  'activity.showAll': '전체 보기 ({count})',
  'activity.showLess': '접기',
  'activity.protected': '공격 감지: 보호막으로 보호했습니다',
  'activity.attackHalted': '공격 감지: 보호막 미확인',
  'shieldWatch.captureOpen': '그 순간의 스크린샷 보기',
  'shieldWatch.captureLoading': '스크린샷 불러오는 중…',
  'shieldWatch.captureAlt': '봇이 판단한 순간의 스크린샷',
  'shieldWatch.captureGone': '이 스크린샷은 없습니다: 봇당 최근 5개만 보관합니다.',
  'shieldWatch.captureClose': '닫기',
  'shieldWatch.help': '감시할 성의 좌표를 입력하세요. 봇이 주기적으로 보호막이 남아 있는지 확인하고, 사라지면 이메일로 알려드립니다.',
  'shieldWatch.interval': '간격',
  'shieldWatch.region': '지역',
  'shieldWatch.needCoords': '감시할 플레이어의 X, Y 좌표를 입력하세요.',
  'shieldWatch.idleNote': '확인은 봇의 유휴 시간에 실행됩니다. 농사가 바쁘면 간격이 늘어날 수 있습니다.',
  'shieldWatch.stateShielded': '대상이 아직 보호막을 유지 중',
  'shieldWatch.stateConfirming': '보호막 없음: 확인 중…',
  'shieldWatch.stateDown': '보호막이 사라졌습니다!',
  'shieldWatch.stateMoved': '대상이 해당 좌표에 없습니다',
  'shieldWatch.stateNoDetector': '감시 불가: 감지기를 사용할 수 없음',
  'intelligence.mappingNoRegion': '설정 → 정보 매핑에서 지역을 선택하고 확인하면 진행률이 표시됩니다.',

  'support.title': '지원',
  'support.subtitle': '고객 지원 — 바로 여기서 답변드립니다.',
  'support.open': '지원 채팅 열기',
  'support.close': '지원 채팅 닫기',
  'support.empty': '도움이 필요하신가요? 문제를 알려주세요(스크린샷 첨부 가능). 이 채팅에서 답변드립니다.',
  'support.placeholder': '메시지를 입력하세요…',
  'support.send': '보내기',
  'support.sending': '보내는 중…',
  'support.attach': '스크린샷 첨부',
  'support.attachRemove': '이미지 제거',
  'support.attachTooBig': '이미지가 5MB보다 큽니다.',
  'support.attachNotImage': '이미지만 첨부할 수 있습니다.',
  'support.imageAlt': '첨부된 스크린샷',
  'support.you': '나',
  'support.agent': '지원팀',
  'support.sendError': '메시지를 보낼 수 없습니다. 다시 시도하세요.',
  'support.loading': '대화 불러오는 중…',
  'support.unreadLabel': '새 지원 메시지 {count}건'
};

export const zh: Record<TranslationKey, string> = {
  'app.account': '帳號',
  'app.configuration': '設定',
  'app.configurationUnavailable': '設定不可用',
  'app.faq': '常見問題',
  'app.faqButton': '常見問題',
  'app.guide': '指南',
  'app.guideButton': '查看安裝指南',
  'app.language': '語言',
  'app.license': '授權',
  'app.manageBilling': '管理訂閱',
  'app.subscribe': '訂閱',
  'app.openAccountMenu': '開啟帳號選單',
  'app.signOut': '登出',
  'app.billingError': '無法開啟付款入口。',
  'app.billingNoStripe': '您的授權不是透過 Stripe 管理（手動授予的存取權）：沒有可管理的付款。',
  'app.product': 'White Bot Desktop',

  'auth.title': 'White Bot',
  'auth.subtitle': 'Desktop 方案 · 每月 €11.99 · 5 天免費試用',
  'auth.betaSubtitle': '免費測試版',
  'auth.intro': '登入以管理您的機器人。',
  'auth.email': '電子郵件',
  'auth.placeholderEmail': 'you@email.com',
  'auth.sendLink': '傳送登入連結',
  'auth.googleLogin': '使用 Google 登入',
  'auth.checkEmail': '請查看您的信箱：我們已寄出登入連結。',
  'auth.loadingSession': '正在載入工作階段…',

  'entitlement.checking': '正在確認訂閱…',
  'entitlement.active': '生效中',
  'entitlement.trialing': '試用中',
  'entitlement.past_due': '待付款',
  'entitlement.canceled': '已取消',
  'entitlement.inactive': '未啟用',

  'pills.connected': '用戶端已連線',
  'pills.disconnected': '用戶端已離線',

  'dashboard.actions': '操作',
  'dashboard.autoBot': '自動機器人',
  'dashboard.collect': '採集資源',
  'dashboard.trainTroops': '訓練部隊',
  'dashboard.autoHunt': '自動狩獵',
  'dashboard.stopBot': '停止機器人',
  'dashboard.screenshot': '截圖',
  'dashboard.mockView': '模擬畫面 — 用戶端尚未傳送截圖',
  'dashboard.marches': '行軍',
  'dashboard.training': '訓練',
  'dashboard.noRecentVerification': '近期沒有檢查',
  'dashboard.queue': '佇列',
  'dashboard.state': '狀態',
  'dashboard.activity': '活動',
  'dashboard.lastReport': '最後回報',
  'dashboard.clientVersion': '用戶端版本',
  'dashboard.never': '從未',
  'dashboard.disconnectedNotice': '用戶端已有一段時間沒有回報。請確認它與 BlueStacks 一起在您的電腦上執行。',
  'dashboard.settingsSaved': '設定已儲存。',
  'dashboard.client': '用戶端',
  'dashboard.clientBody': '在您的電腦下載並安裝用戶端（Windows + BlueStacks），用您的帳號啟用。',
  'dashboard.clientDownload': '下載用戶端（正式版推出時提供）',
  'dashboard.clientDownloadReady': '下載用戶端（測試版）',
  'dashboard.clientSmartscreen': '以 ZIP 下載：解壓縮後執行安裝程式。未簽章的測試版：若瀏覽器或 Windows 提出警告，請選「保留」與「其他資訊 → 仍要執行」。',

  'op.workingEyebrow': '操作進行中',
  'op.successEyebrow': '已完成',
  'op.errorEyebrow': '未確認',
  'op.warningEyebrow': '注意',
  'op.startTitle': '正在啟動{action}',
  'op.startBody': '指令已送出。您電腦上的用戶端幾秒內就會收到。',
  'op.stopTitle': '正在停止機器人',
  'op.stopBody': '指令已送出。機器人會完成目前步驟後停止。',
  'op.successStartTitle': '機器人執行中',
  'op.successStartBody': '用戶端已確認正在執行。',
  'op.successStopTitle': '機器人已停止',
  'op.successStopBody': '用戶端已確認停止。',
  'op.timeoutTitle': '用戶端未確認',
  'op.timeoutBody': '指令已儲存，用戶端連線後就會生效。請確認用戶端在您的電腦上開啟。',
  'op.disconnectedTitle': '用戶端已離線',
  'op.disconnectedBody': '您的機器人目前沒有回報。請在電腦上開啟用戶端（連同 BlueStacks）後再試。您仍然可以送出指令。',
  'op.sendAnyway': '仍要送出',
  'op.close': '關閉',
  'op.cancel': '取消',

  'settings.level': '等級',
  'settings.marches': '行軍',
  'settings.amount': '每批數量',
  'settings.type': '類型',
  'settings.beasts': '野獸（10 體力）',
  'settings.terror': '極地驚魂（25 體力）',
  'settings.timer': '集結等待',
  'settings.up': '增加',
  'settings.down': '減少',
  'settings.resources.iron': '鐵礦',
  'settings.resources.coal': '煤炭',
  'settings.resources.wood': '木材',
  'settings.resources.meat': '肉類',
  'settings.units.infantry': '盾兵',
  'settings.units.lancer': '槍兵',
  'settings.units.marksman': '弓兵',
  'settings.autoHelp': '自動協助',
  'settings.autoHeal': '自動治療',
  'settings.autoShield': '自動護盾',
  'settings.tasks': '任務',
  'settings.tasksEnable': '啟用自動任務',
  'settings.tasksHint': '每日獎勵與任務：郵件、免費英雄、閒置寶箱和情報任務。依排程自動執行。',
  'settings.taskMail': '郵件（領取）',
  'settings.taskHeroes': '免費英雄',
  'settings.taskIdle': '閒置寶箱',
  'settings.taskIntel': '情報任務',
  // 情報測繪 (0.6.4, doc 17)
  'settings.intelMapping': '情報測繪',
  'settings.intelEnable': '啟用情報測繪',
  'settings.intelHint': '你的機器人會探索所選區域的地圖，為情報網路提供資料。每掃描一格即可獲得代幣，用於支付查詢。',
  'settings.intelRegion': '要測繪的區域',
  'settings.intelRegionHint': '3 到 5 位數字（例如 4347）。通常是你自己的區域。',
  'settings.intelCheckRegion': '檢查區域',
  'settings.intelChecking': '正在檢查區域…',
  'settings.intelRegionReady': '區域 {region} 已在網路中（{total} 格）。可以開始測繪。',
  'settings.intelRegionSeeded': '區域 {region} 已加入網路（{total} 格）。你的機器人可以開始測繪了。',
  'settings.intelRegionInvalid': '區域無效：請輸入 3 到 5 位數字。',
  'settings.intelRegionError': '無法檢查該區域，請再試一次。',
  'settings.intelCellsPerPass': '每輪掃描格數',
  'settings.intelCellsPerPassHint': '機器人每輪測繪掃描多少格，之後再繼續其他任務。',
  'settings.game': '遊戲',
  'settings.gameLanguage': '遊戲語言',
  'settings.gameLanguageEn': '英文（預設）',
  'settings.gameLanguageEs': '西班牙文',
  'settings.gameLanguageHint': '這是 BlueStacks 內「遊戲」的語言（不是本網站的語言）。機器人只能讀取英文或西班牙文的遊戲畫面：請在遊戲的設定 → 語言中設定，並在此選擇相同語言。',
  'settings.cryptids': '優先獵殺神秘生物（活動）',
  'settings.cryptidsHint': '當狂暴神秘生物活動進行中且您持有神秘生物號角時，狩獵會將其用於神秘生物；沒有活動或號角時照常狩獵（擊殺野獸會掉落號角）。',
  'status.hunting_cryptid': '正在尋找活動神秘生物…',

  'subscribe.title': '免費試用 White Bot 5 天',
  'subscribe.body': '在您自己的電腦上執行 White Bot（Windows + BlueStacks），並從本網站控制。',
  'subscribe.trial': '試用',
  'subscribe.trialValue': '免費 5 天',
  'subscribe.after': '之後',
  'subscribe.afterValue': '每月 €11.99',
  'subscribe.includes': '包含',
  'subscribe.includesValue': '採集 · 部隊 · 狩獵 · 治療 · 護盾 · 聯盟協助 · 每日任務',
  'subscribe.cancel': '取消',
  'subscribe.cancelValue': '隨時可取消',
  'subscribe.cta': '開始免費試用（5 天）',
  'subscribe.ctaOpening': '正在開啟付款…',
  'subscribe.cardNote': '試用不需要信用卡。只有在試用結束後決定訂閱時才需付款。',
  'subscribe.trialCta': '開始 5 天免費試用 — 免信用卡',
  'subscribe.trialStarting': '正在啟用試用…',
  'subscribe.trialError': '無法啟用試用，請再試一次。',
  'subscribe.trialUsed': '此帳號已使用過免費試用。',
  'subscribe.payCta': '訂閱 — 每月 €11.99',
  'subscribe.endedTitle': '您的存取權已結束',
  'subscribe.endedBody': '您的試用或訂閱已結束。訂閱即可繼續在電腦上使用 White Bot — 您的設定將被保留。',
  'subscribe.checkoutError': '啟動付款時發生錯誤',
  'subscribe.hostedNote': '使用託管服務（在我們的伺服器上執行）？那是另一項產品：',
  'subscribe.hostedLink': '前往 whitebot.app',

  'beta.banner': '免費測試版',
  'subscribe.betaTitle': 'White Bot，測試期間免費',
  'subscribe.betaTrial': '測試版',
  'subscribe.betaTrialValue': '免費至 2026/8/15',
  'subscribe.betaTrialCta': '開始免費測試',
  'subscribe.betaCardNote': '不需要信用卡。White Bot 在測試期間免費，直到 2026 年 8 月 15 日。',
  'subscribe.betaEndedNote': '免費測試進行中。若您沒有存取權，請透過支援聊天與我們聯繫。',

  'tutorial.title': '快速上手',
  'tutorial.intro': '三個步驟，讓機器人在您的電腦上運作並由此控制。',
  'tutorial.step1Title': '1. 安裝用戶端',
  'tutorial.step1Body': '下載用戶端並與 BlueStacks 一起安裝到電腦。指南會逐步引導您。',
  'tutorial.step2Title': '2. 用電子郵件啟用',
  'tutorial.step2Body': '開啟用戶端並輸入您的電子郵件。連線後，這裡會顯示「用戶端已連線」。',
  'tutorial.step3Title': '3. 從這裡控制機器人',
  'tutorial.step3Body': '選擇模組與設定，按下操作，並在此面板追蹤截圖與狀態。',
  'tutorial.dontShowAgain': '不再顯示',
  'tutorial.notNow': '暫時不要',
  'tutorial.gotIt': '知道了',

  'pills.license': '授權：{label}',

  'dashboard.refreshCapture': '重新整理截圖',
  'dashboard.refreshCapturePending': '擷取中…',
  'dashboard.refreshCaptureTimeout': '用戶端未回應截圖請求。請確認它在您的電腦上開啟。',

  'state.idle': '閒置',
  'state.running': '執行中',
  'state.waiting': '等待中',
  'state.starting': '啟動中',
  'state.verifying': '檢查中',
  'state.training': '訓練中',
  'state.collecting': '採集中',
  'state.hunting': '狩獵中',
  'state.helping': '協助中',
  'state.healing': '治療中',
  'state.recovering': '復原中',
  'state.reconnecting': '重新連線中',
  'state.shielded': '護盾啟用',
  'state.error': '錯誤',

  'status.no_client': '沒有已連線的用戶端。',
  'status.idle': '待命中（已從網頁停止）。',
  'status.running': '執行中：{modules}',
  'status.running_none': '執行中（沒有啟用的模組）。',
  'status.shielded': '自動護盾已啟動保護：機器人已停止。按「停止」再重新「啟動」即可繼續。',
  'shieldAlarm.eyebrow': '自動護盾',
  'shieldAlarm.title': '我們為你擋下了一次攻擊',
  'shieldAlarm.body': '我們偵測到針對 {name} 的攻擊，並自動啟動了護盾。你的部隊已召回，領地安全無虞。為安全起見機器人已停止，按「啟動」即可繼續。',
  'shieldAlarm.time': '攻擊時間',
  'shieldAlarm.close': '知道了',
  'status.starting': '啟動檢查：清理畫面並確認城市中…',
  'status.waiting': '目前無事可做。{time}後再次檢查。',
  'status.backoff_wait': '復原進行中；{time}後重試。',
  'status.verifying_training': '正在檢查訓練佇列…',
  'status.verifying_marches': '正在檢查行軍佇列…',
  'status.verifying_hunt': '正在檢查狩獵行軍…',
  'status.training_collect': '正在收取完成的部隊：{units}',
  'langWarn.eyebrow': '遊戲語言',
  'langWarn.title': '請將遊戲設為英文',
  'langWarn.body': 'White Bot 無法讀取您的遊戲：語言不受支援。請在 Whiteout Survival 開啟 設定 → Language 並選擇 English。切換後機器人會自動繼續。',
  'langWarn.close': '知道了',
  'fleet.title': '我的機器人',
  'fleet.counter': '{n}/{max} 個機器人',
  'fleet.startAll': '全部啟動',
  'fleet.stopAll': '全部停止',
  'fleet.delete': '刪除',
  'fleet.deleteConfirmTitle': '刪除 {name}？',
  'fleet.deleteConfirmBody': '將釋放帳號上限的一個名額。若該機器人的用戶端仍在您的電腦上執行，下次回報時會再次出現。',
  'fleet.deleteConfirm': '刪除機器人',
  'fleet.deleteCancel': '取消',
  'fleet.back': '所有機器人',
  'fleet.empty': '還沒有機器人。在您的電腦上開啟 White Bot Client（每個 BlueStacks 實例一個主控台），它們會自動出現在這裡。',
  'fleet.defaultName': '機器人',
  'fleet.lastReport': '最後回報',
  'status.unsupported_language': '遊戲語言不受支援 — 請改為英文',
  'status.language_autofix': '語言不受支援：正在自動將遊戲切換為英文…',
  'status.dailies': '正在領取每日獎勵…',
  'status.intel_missions': '情報任務中…',
  'status.intel_map_scanning': '情報測繪：已掃描 {cells} 格（+{tokens} 代幣）',
  'status.intel_map_region_done': '情報測繪：區域已是最新',
  'status.intel_map_detector_missing': '情報測繪：偵測器不可用',
  'status.intel_map_region_missing': '情報測繪：請在設定中選擇區域',
  'state.intel': '情報',
  'state.dailies': '每日獎勵',
  'status.language_fixed': '已切換為英文；等待遊戲重新啟動…',
  'state.fixing_language': '正在切換語言',
  'state.blocked_language': '語言不受支援',
  'status.training_units': '正在訓練部隊：{units}（{percent}%）',
  'status.collecting_send': '正在派出採集行軍：{resource}（等級 {level}）',
  'status.hunting_send': '正在派出狩獵攻擊：{type} 等級 {level}',
  'status.helping': '正在檢查聯盟自動協助…',
  'status.healing': '正在檢查自動治療…',
  'status.recovering_attempt': '復原中（{attempt}/{max}）；{time}後重試…',
  'status.recovered_ui': '故障（{task}）後畫面已復原。繼續中…',
  'status.relaunching': '因重複失敗，正在重新啟動 BlueStacks/遊戲…',
  'status.relaunched': '故障後已重新啟動遊戲。{time}後繼續。',
  'status.hand_guide': '偵測到教學指引手勢：點擊其指示位置…',
  'status.reconnecting': '帳號在其他裝置登入：正在按「重新連線」…',
  'status.backoff_init_error': '初始化錯誤（{detail}）。{time}後自動重試。',
  'status.backoff_no_adb': '無法連線 BlueStacks（ADB）。請確認 BlueStacks 已開啟。{time}後重試。',
  'status.backoff_failure': '重複失敗（{task}）。{time}後自動重試。',
  'status.backoff_blocked': '畫面被鎖定（{kind}）。{time}後自動重試。',

  'statusTask.verify_training': '訓練佇列檢查',
  'statusTask.collect_completed': '收取完成的部隊',
  'statusTask.train_flow': '訓練流程',
  'statusTask.return_after_training': '訓練後返回城市',
  'statusTask.verify_marches': '行軍檢查',
  'statusTask.collect_flow': '採集流程',
  'statusTask.hunt_capture': '狩獵狀態截圖',
  'statusTask.verify_hunt': '狩獵行軍檢查',
  'statusTask.hunt_vigor': '體力讀取',
  'statusTask.hunt_flow': '狩獵流程',
  'statusTask.auto_heal': '自動治療',
  'statusTask.startup_return': '啟動時返回城市',
  'statusTask.startup_screen': '啟動時出現無法辨識的畫面',
  'statusTask.unexpected': '未預期的錯誤',

  'intelligence.title': '情報',
  'intelligence.intro': '查詢 White Bot 網路收集的玩家與聯盟。每天 {limit} 次查詢。',
  'intelligence.region': '區域',
  'intelligence.regionPlaceholder': '區域（例如 4347）',
  'intelligence.searchPlayer': '搜尋玩家或聯盟',
  'intelligence.searchPlaceholder': '玩家或聯盟（留空 = 整個區域）',
  'intelligence.regionSearchTitle': '整個區域 {region}',
  'intelligence.errorUnknownRegion': '該區域尚未加入網路（請確認編號）。',
  'intelligence.quotaRemainingValue': '{limit} 次中剩 {remaining} 次',
  'intelligence.request': '搜尋',
  'intelligence.requesting': '搜尋中…',
  'intelligence.quotaRemaining': '今天剩餘查詢',
  'intelligence.minChars': '請輸入至少 3 個字元，或留空以列出整個區域。',
  'intelligence.regionRequired': '請輸入要搜尋的區域（例如 4347）。',
  'intelligence.loading': '正在載入查詢…',
  'intelligence.empty': '還沒有查詢。',
  'intelligence.delete': '刪除查詢',
  'intelligence.power': '戰力',
  'intelligence.coordinates': '座標',
  'intelligence.notFound': '沒有相符結果。',
  'intelligence.noResult': '結果待定（該區域尚無資料）。',
  'intelligence.statusPending': '排隊中',
  'intelligence.statusProcessing': '搜尋中',
  'intelligence.statusCompleted': '已完成',
  'intelligence.statusNotFound': '未找到',
  'intelligence.statusFailed': '無法取得結果',
  'intelligence.errorQuota': '今天的查詢已用完。明天再來吧。',
  'intelligence.errorPending': '該查詢已在進行中。',
  'intelligence.errorNoRegion': '請輸入有效的區域。',
  'intelligence.errorGeneric': '無法完成搜尋，請再試一次。',
  'intelligence.search': '搜尋',
  'intelligence.resultsFound': '{count} 筆結果',
  'intelligence.showMore': '再顯示 {count} 筆',
  'intelligence.showLess': '收合',
  'intelligence.sortResults': '排序',
  'intelligence.sortPower': '戰力',
  'intelligence.sortName': '名稱',
  'intelligence.lastSeen': '最後出現',
  'intelligence.deleteConfirm': '要從面板移除「{name}」嗎？該查詢仍計入每日限額。',
  // 代幣經濟 + 測繪進度 (0.6.4, doc 17)
  'intelligence.tokensChip': '{n} 代幣',
  'intelligence.freeChip': '今日免費 {n} 次',
  'intelligence.freeTodayLabel': '今日免費查詢',
  'intelligence.tokensBalance': '代幣餘額',
  'intelligence.costsLine': '代幣費用：查詢 {search} · 整個區域 {region}',
  'intelligence.noTokensCta': '免費查詢和代幣都用完了：在設定中啟用情報測繪，機器人掃描地圖即可賺取代幣。',
  'intelligence.errorTokens': '代幣不足，無法進行此查詢。啟用測繪來賺取更多。',
  'intelligence.mappingTitle': '測繪進度',
  'intelligence.mappingCells': '{total} 格中已掃描 {scanned} 格',
  'intelligence.mappingToday': '今日由你的機器人掃描',
  'intelligence.mappingEarnedToday': '今日獲得的代幣',
  'shieldWatch.toggle': '監視玩家的護盾（此機器人將停止繪製地圖）',
  'shieldWatch.title': 'Shield Monitor',
  'shieldWatch.historyTitle': '監視紀錄',
  'activity.title': '情報活動',
  'activity.showAll': '顯示全部（{count}）',
  'activity.showLess': '收起',
  'activity.protected': '偵測到攻擊：已為你開啟護盾',
  'activity.attackHalted': '偵測到攻擊：護盾未確認',
  'shieldWatch.captureOpen': '查看當下的截圖',
  'shieldWatch.captureLoading': '正在載入截圖…',
  'shieldWatch.captureAlt': '機器人判斷當下的截圖',
  'shieldWatch.captureGone': '這張截圖已不存在：每個機器人只保留最近 5 張。',
  'shieldWatch.captureClose': '關閉',
  'shieldWatch.help': '輸入要監視的城堡座標。機器人會定期檢查其護盾是否還在，護盾消失時以電子郵件通知您。',
  'shieldWatch.interval': '每隔',
  'shieldWatch.region': '區域',
  'shieldWatch.needCoords': '請輸入要監視玩家的 X 與 Y 座標。',
  'shieldWatch.idleNote': '檢查會在機器人空閒時進行；農場繁忙時間隔可能拉長。',
  'shieldWatch.stateShielded': '目標護盾仍在',
  'shieldWatch.stateConfirming': '沒有護盾：確認中…',
  'shieldWatch.stateDown': '護盾已消失！',
  'shieldWatch.stateMoved': '目標已不在該座標',
  'shieldWatch.stateNoDetector': '無法監視：偵測器不可用',
  'intelligence.mappingNoRegion': '在「設定 → 情報測繪」中選擇並檢查區域，即可查看進度。',

  'support.title': '支援',
  'support.subtitle': '客戶支援 — 我們就在這裡回覆。',
  'support.open': '開啟支援聊天',
  'support.close': '關閉支援聊天',
  'support.empty': '需要協助嗎？告訴我們問題（可附上截圖），我們會在此聊天中回覆。',
  'support.placeholder': '輸入訊息…',
  'support.send': '傳送',
  'support.sending': '傳送中…',
  'support.attach': '附上截圖',
  'support.attachRemove': '移除圖片',
  'support.attachTooBig': '圖片超過 5 MB。',
  'support.attachNotImage': '只能附加圖片。',
  'support.imageAlt': '附加的截圖',
  'support.you': '您',
  'support.agent': '支援',
  'support.sendError': '訊息無法傳送，請再試一次。',
  'support.loading': '正在載入對話…',
  'support.unreadLabel': '{count} 則新的支援訊息'
};

export const ja: Record<TranslationKey, string> = {
  'app.account': 'アカウント',
  'app.configuration': '設定',
  'app.configurationUnavailable': '設定は利用できません',
  'app.faq': 'FAQ',
  'app.faqButton': 'よくある質問',
  'app.guide': 'ガイド',
  'app.guideButton': 'インストールガイドを見る',
  'app.language': '言語',
  'app.license': 'ライセンス',
  'app.manageBilling': 'サブスクリプション管理',
  'app.subscribe': '購読する',
  'app.openAccountMenu': 'アカウントメニューを開く',
  'app.signOut': 'ログアウト',
  'app.billingError': '決済ポータルを開けませんでした。',
  'app.billingNoStripe': 'ライセンスはStripeで管理されていません（手動で付与されたアクセス）：管理する支払いはありません。',
  'app.product': 'White Bot Desktop',

  'auth.title': 'White Bot',
  'auth.subtitle': 'Desktopプラン · 月額€11.99 · 5日間無料体験',
  'auth.betaSubtitle': '無料ベータ',
  'auth.intro': 'ログインしてボットを管理しましょう。',
  'auth.email': 'メールアドレス',
  'auth.placeholderEmail': 'you@email.com',
  'auth.sendLink': 'ログインリンクを送信',
  'auth.googleLogin': 'Googleでログイン',
  'auth.checkEmail': 'メールをご確認ください：ログインリンクを送信しました。',
  'auth.loadingSession': 'セッションを読み込み中…',

  'entitlement.checking': 'サブスクリプションを確認中…',
  'entitlement.active': '有効',
  'entitlement.trialing': '体験中',
  'entitlement.past_due': '支払い待ち',
  'entitlement.canceled': 'キャンセル済み',
  'entitlement.inactive': '無効',

  'pills.connected': 'クライアント接続中',
  'pills.disconnected': 'クライアント切断',

  'dashboard.actions': 'アクション',
  'dashboard.autoBot': 'オートボット',
  'dashboard.collect': '資源採集',
  'dashboard.trainTroops': '部隊訓練',
  'dashboard.autoHunt': 'オート狩猟',
  'dashboard.stopBot': 'ボット停止',
  'dashboard.screenshot': 'スクリーンショット',
  'dashboard.mockView': 'シミュレーション表示 — クライアントからまだキャプチャが届いていません',
  'dashboard.marches': '行軍',
  'dashboard.training': '訓練',
  'dashboard.noRecentVerification': '最近の確認はありません',
  'dashboard.queue': 'キュー',
  'dashboard.state': '状態',
  'dashboard.activity': 'アクティビティ',
  'dashboard.lastReport': '最終報告',
  'dashboard.clientVersion': 'クライアントのバージョン',
  'dashboard.never': 'なし',
  'dashboard.disconnectedNotice': 'クライアントからしばらく報告がありません。PCでBlueStacksと一緒に起動しているか確認してください。',
  'dashboard.settingsSaved': '設定を保存しました。',
  'dashboard.client': 'クライアント',
  'dashboard.clientBody': 'PCにクライアントをダウンロードしてインストールしてください（Windows + BlueStacks）。アカウントで有効化されます。',
  'dashboard.clientDownload': 'クライアントをダウンロード（正式版で提供）',
  'dashboard.clientDownloadReady': 'クライアントをダウンロード（ベータ）',
  'dashboard.clientSmartscreen': 'ZIPでダウンロードされます：展開してインストーラーを実行してください。未署名のベータ版のため、ブラウザやWindowsが警告した場合は「保持」→「詳細情報 → 実行」を選択してください。',

  'op.workingEyebrow': '処理中',
  'op.successEyebrow': '完了',
  'op.errorEyebrow': '確認なし',
  'op.warningEyebrow': '注意',
  'op.startTitle': '{action}を開始中',
  'op.startBody': '指示を送信しました。PCのクライアントが数秒以内に受け取ります。',
  'op.stopTitle': 'ボットを停止中',
  'op.stopBody': '指示を送信しました。ボットは現在のステップを終えて停止します。',
  'op.successStartTitle': 'ボット稼働中',
  'op.successStartBody': 'クライアントが実行を確認しました。',
  'op.successStopTitle': 'ボット停止済み',
  'op.successStopBody': 'クライアントが停止を確認しました。',
  'op.timeoutTitle': 'クライアントが確認しませんでした',
  'op.timeoutBody': '指示は保存済みで、クライアントが接続したときに適用されます。PCでクライアントが起動しているか確認してください。',
  'op.disconnectedTitle': 'クライアント切断',
  'op.disconnectedBody': 'ボットが現在報告していません。PCでクライアントを（BlueStacksと一緒に）開いて再試行してください。指示は今でも送信できます。',
  'op.sendAnyway': 'それでも送信',
  'op.close': '閉じる',
  'op.cancel': 'キャンセル',

  'settings.level': 'レベル',
  'settings.marches': '行軍',
  'settings.amount': '1回あたりの数量',
  'settings.type': 'タイプ',
  'settings.beasts': '野獣（スタミナ10）',
  'settings.terror': '極地の恐怖（スタミナ25）',
  'settings.timer': '集結待機',
  'settings.up': '増やす',
  'settings.down': '減らす',
  'settings.resources.iron': '鉄',
  'settings.resources.coal': '石炭',
  'settings.resources.wood': '木材',
  'settings.resources.meat': '肉',
  'settings.units.infantry': '盾兵',
  'settings.units.lancer': '槍兵',
  'settings.units.marksman': '射手',
  'settings.autoHelp': 'オート支援',
  'settings.autoHeal': 'オート治療',
  'settings.autoShield': 'オートシールド',
  'settings.tasks': 'タスク',
  'settings.tasksEnable': '自動タスクを有効化',
  'settings.tasksHint': 'デイリー報酬とミッション：メール、無料ヒーロー、放置報酬、諜報ミッション。定期的に自動実行。',
  'settings.taskMail': 'メール（受取）',
  'settings.taskHeroes': '無料ヒーロー',
  'settings.taskIdle': '放置報酬',
  'settings.taskIntel': '諜報ミッション',
  // インテリジェンスマッピング (0.6.4, doc 17)
  'settings.intelMapping': 'インテリジェンスマッピング',
  'settings.intelEnable': 'インテリジェンスマッピングを有効にする',
  'settings.intelHint': 'ボットが選択したサーバーのマップを探索し、インテリジェンスネットワークにデータを提供します。スキャンしたマスごとに検索に使えるトークンを獲得できます。',
  'settings.intelRegion': 'マッピングするサーバー',
  'settings.intelRegionHint': '3〜5桁の数字（例: 4347）。通常は自分のサーバーです。',
  'settings.intelCheckRegion': 'サーバーを確認',
  'settings.intelChecking': 'サーバーを確認中…',
  'settings.intelRegionReady': 'サーバー{region}はすでにネットワークにあります（{total}マス）。マッピングを開始できます。',
  'settings.intelRegionSeeded': 'サーバー{region}をネットワークに追加しました（{total}マス）。ボットがマッピングを開始できます。',
  'settings.intelRegionInvalid': '無効なサーバーです。3〜5桁の数字を入力してください。',
  'settings.intelRegionError': 'サーバーを確認できませんでした。もう一度お試しください。',
  'settings.intelCellsPerPass': '1回あたりのマス数',
  'settings.intelCellsPerPassHint': 'ほかのタスクに戻る前に、1回のマッピングで何マスをスキャンするかを設定します。',
  'settings.game': 'ゲーム',
  'settings.gameLanguage': 'ゲームの言語',
  'settings.gameLanguageEn': '英語（デフォルト）',
  'settings.gameLanguageEs': 'スペイン語',
  'settings.gameLanguageHint': 'これはBlueStacks内の「ゲーム」の言語です（このサイトの言語ではありません）。ボットは英語またはスペイン語のゲーム画面しか読めません：ゲームの設定 → 言語で設定し、ここでも同じものを選んでください。',
  'settings.cryptids': 'クリプティッド優先（イベント）',
  'settings.cryptidsHint': 'バーサーククリプティッドのイベント開催中でクリプティッドの角を持っている場合、狩猟はそれをクリプティッドに使います。イベントや角がなければ通常どおり狩ります（野獣を倒すと角がドロップします）。',
  'status.hunting_cryptid': 'イベントのクリプティッドを探しています…',

  'subscribe.title': 'White Botを5日間無料で試す',
  'subscribe.body': '自分のPCでWhite Botを動かし（Windows + BlueStacks）、このサイトから操作します。',
  'subscribe.trial': '体験',
  'subscribe.trialValue': '5日間無料',
  'subscribe.after': 'その後',
  'subscribe.afterValue': '月額€11.99',
  'subscribe.includes': '含まれる機能',
  'subscribe.includesValue': '採集 · 部隊 · 狩猟 · 治療 · シールド · 同盟支援 · デイリータスク',
  'subscribe.cancel': '解約',
  'subscribe.cancelValue': 'いつでも',
  'subscribe.cta': '無料体験を開始（5日間）',
  'subscribe.ctaOpening': '決済を開いています…',
  'subscribe.cardNote': '体験にカードは不要です。体験終了後に購読を決めた場合のみ支払いが発生します。',
  'subscribe.trialCta': '5日間の無料体験を開始 — カード不要',
  'subscribe.trialStarting': '体験を有効化しています…',
  'subscribe.trialError': '体験を有効化できませんでした。もう一度お試しください。',
  'subscribe.trialUsed': 'このアカウントでは無料体験を使用済みです。',
  'subscribe.payCta': '購読する — 月額€11.99',
  'subscribe.endedTitle': 'ご利用期間が終了しました',
  'subscribe.endedBody': '体験またはサブスクリプションが終了しました。購読すればPCでWhite Botを引き続き使えます — 設定は保持されます。',
  'subscribe.checkoutError': '決済の開始エラー',
  'subscribe.hostedNote': 'ホスト版（当社サーバーで稼働）をご利用ですか？それは別の製品です：',
  'subscribe.hostedLink': 'whitebot.appへ',

  'beta.banner': '無料ベータ',
  'subscribe.betaTitle': 'ベータ期間中は無料のWhite Bot',
  'subscribe.betaTrial': 'ベータ',
  'subscribe.betaTrialValue': '2026年8月15日まで無料',
  'subscribe.betaTrialCta': '無料ベータを開始',
  'subscribe.betaCardNote': 'カードは不要です。White Botはベータ期間中の2026年8月15日まで無料です。',
  'subscribe.betaEndedNote': '無料ベータ中です。アクセスできない場合はサポートチャットでご連絡ください。',

  'tutorial.title': 'はじめの一歩',
  'tutorial.intro': 'PCでボットを動かし、ここから操作するまでの3ステップ。',
  'tutorial.step1Title': '1. クライアントをインストール',
  'tutorial.step1Body': 'クライアントをダウンロードし、BlueStacksと一緒にPCへインストールします。ガイドが手順を案内します。',
  'tutorial.step2Title': '2. メールアドレスで有効化',
  'tutorial.step2Body': 'クライアントを開いてメールアドレスを入力します。接続されると、ここに「クライアント接続中」と表示されます。',
  'tutorial.step3Title': '3. ここからボットを操作',
  'tutorial.step3Body': 'モジュールと設定を選び、アクションを押して、このパネルでキャプチャと状態を確認しましょう。',
  'tutorial.dontShowAgain': '今後表示しない',
  'tutorial.notNow': '今はしない',
  'tutorial.gotIt': 'わかった',

  'pills.license': 'ライセンス：{label}',

  'dashboard.refreshCapture': 'キャプチャを更新',
  'dashboard.refreshCapturePending': 'キャプチャ中…',
  'dashboard.refreshCaptureTimeout': 'クライアントがキャプチャ要求に応答しませんでした。PCで起動しているか確認してください。',

  'state.idle': '待機',
  'state.running': '稼働中',
  'state.waiting': '待機中',
  'state.starting': '起動中',
  'state.verifying': '確認中',
  'state.training': '訓練中',
  'state.collecting': '採集中',
  'state.hunting': '狩猟中',
  'state.helping': '支援中',
  'state.healing': '治療中',
  'state.recovering': '復旧中',
  'state.reconnecting': '再接続中',
  'state.shielded': 'シールド有効',
  'state.error': 'エラー',

  'status.no_client': 'クライアントが接続されていません。',
  'status.idle': '待機中（ウェブから停止済み）。',
  'status.running': '稼働中：{modules}',
  'status.running_none': '稼働中（有効なモジュールなし）。',
  'status.shielded': 'オートシールドが保護を発動し、ボットは停止しました。再開するには停止を押してから、もう一度開始してください。',
  'shieldAlarm.eyebrow': 'オートシールド',
  'shieldAlarm.title': '攻撃からあなたを守りました',
  'shieldAlarm.body': '{name} への攻撃を検知し、自動的にシールドを展開しました。部隊は撤退し、拠点は安全です。安全のためボットは停止しました。再開するには開始を押してください。',
  'shieldAlarm.time': '攻撃の時刻',
  'shieldAlarm.close': 'OK',
  'status.starting': '起動チェック：画面を整理して都市を確認しています…',
  'status.waiting': 'やることがありません。次のチェックまで{time}。',
  'status.backoff_wait': '復旧中；{time}後に再試行。',
  'status.verifying_training': '訓練キューを確認中…',
  'status.verifying_marches': '行軍キューを確認中…',
  'status.verifying_hunt': '狩猟の行軍を確認中…',
  'status.training_collect': '完了した部隊を受け取り中：{units}',
  'langWarn.eyebrow': 'ゲームの言語',
  'langWarn.title': 'ゲームを英語に設定してください',
  'langWarn.body': 'White Botがゲームを読み取れません：言語がサポートされていません。Whiteout Survivalの設定 → LanguageでEnglishを選択してください。変更するとボットは自動的に再開します。',
  'langWarn.close': 'わかりました',
  'fleet.title': 'マイボット',
  'fleet.counter': '{n}/{max} ボット',
  'fleet.startAll': 'すべて開始',
  'fleet.stopAll': 'すべて停止',
  'fleet.delete': '削除',
  'fleet.deleteConfirmTitle': '{name}を削除しますか？',
  'fleet.deleteConfirmBody': 'アカウント上限の枠が1つ空きます。そのボットのクライアントがPCでまだ起動中の場合、次回の報告時に再表示されます。',
  'fleet.deleteConfirm': 'ボットを削除',
  'fleet.deleteCancel': 'キャンセル',
  'fleet.back': 'すべてのボット',
  'fleet.empty': 'まだボットがありません。PCでWhite Bot Clientを開くと（BlueStacksインスタンスごとに1つのコンソール）、自動的にここに表示されます。',
  'fleet.defaultName': 'ボット',
  'fleet.lastReport': '最終報告',
  'status.unsupported_language': 'ゲーム言語が未対応 — 英語に変更してください',
  'status.language_autofix': '未対応の言語：ゲームを自動的に英語に切り替えています…',
  'status.dailies': 'デイリー報酬を受け取り中…',
  'status.intel_missions': '諜報ミッション中…',
  'status.intel_map_scanning': 'インテリジェンス：{cells}マスをスキャン（+{tokens}トークン）',
  'status.intel_map_region_done': 'インテリジェンス：サーバーは最新の状態です',
  'status.intel_map_detector_missing': 'インテリジェンス：検出器を利用できません',
  'status.intel_map_region_missing': 'インテリジェンス：設定でサーバーを選択してください',
  'state.intel': '諜報',
  'state.dailies': 'デイリー報酬',
  'status.language_fixed': '英語に切り替えました。ゲームの再起動を待っています…',
  'state.fixing_language': '言語を変更中',
  'state.blocked_language': '未対応の言語',
  'status.training_units': '部隊を訓練中：{units}（{percent}%）',
  'status.collecting_send': '採集の行軍を送信中：{resource}（レベル{level}）',
  'status.hunting_send': '狩猟攻撃を送信中：{type} レベル{level}',
  'status.helping': '同盟のオート支援を確認中…',
  'status.healing': 'オート治療を確認中…',
  'status.recovering_attempt': '復旧中（{attempt}/{max}）；{time}後に再試行…',
  'status.recovered_ui': '障害（{task}）後に画面が復旧しました。続行します…',
  'status.relaunching': '連続した失敗のためBlueStacks/ゲームを再起動しています…',
  'status.relaunched': '障害後にゲームを再起動しました。{time}後に再開します。',
  'status.hand_guide': 'チュートリアルの手を検出：指し示す場所をタップしています…',
  'status.reconnecting': '別の端末でセッションが開かれました：「再接続」を押しています…',
  'status.backoff_init_error': '初期化エラー（{detail}）。{time}後に自動再試行。',
  'status.backoff_no_adb': 'BlueStacks（ADB）に接続できません。BlueStacksが開いているか確認してください。{time}後に再試行。',
  'status.backoff_failure': '繰り返しの失敗（{task}）。{time}後に自動再試行。',
  'status.backoff_blocked': '画面がブロックされています（{kind}）。{time}後に自動再試行。',

  'statusTask.verify_training': '訓練キューの確認',
  'statusTask.collect_completed': '完了部隊の受け取り',
  'statusTask.train_flow': '訓練フロー',
  'statusTask.return_after_training': '訓練後の都市への帰還',
  'statusTask.verify_marches': '行軍の確認',
  'statusTask.collect_flow': '採集フロー',
  'statusTask.hunt_capture': '狩猟状態のキャプチャ',
  'statusTask.verify_hunt': '狩猟行軍の確認',
  'statusTask.hunt_vigor': 'スタミナの読み取り',
  'statusTask.hunt_flow': '狩猟フロー',
  'statusTask.auto_heal': 'オート治療',
  'statusTask.startup_return': '起動時の都市への帰還',
  'statusTask.startup_screen': '起動時の未認識画面',
  'statusTask.unexpected': '予期しないエラー',

  'intelligence.title': 'インテリジェンス',
  'intelligence.intro': 'White Botネットワークが収集したプレイヤーと同盟を検索。1日{limit}回まで。',
  'intelligence.region': 'サーバー',
  'intelligence.regionPlaceholder': 'サーバー（例：4347）',
  'intelligence.searchPlayer': 'プレイヤーまたは同盟を検索',
  'intelligence.searchPlaceholder': 'プレイヤーまたは同盟（空欄 = サーバー全体）',
  'intelligence.regionSearchTitle': 'サーバー{region}全体',
  'intelligence.errorUnknownRegion': 'そのサーバーはまだネットワークにありません（番号を確認してください）。',
  'intelligence.quotaRemainingValue': '{limit}回中あと{remaining}回',
  'intelligence.request': '検索',
  'intelligence.requesting': '検索中…',
  'intelligence.quotaRemaining': '今日の残り検索回数',
  'intelligence.minChars': '3文字以上入力するか、空欄のままでサーバー全体を一覧表示します。',
  'intelligence.regionRequired': '検索するサーバーを入力してください（例：4347）。',
  'intelligence.loading': '検索履歴を読み込み中…',
  'intelligence.empty': 'まだ検索がありません。',
  'intelligence.delete': '検索を削除',
  'intelligence.power': '戦力',
  'intelligence.coordinates': '座標',
  'intelligence.notFound': '一致する結果がありません。',
  'intelligence.noResult': '結果待ち（そのサーバーにはまだデータがありません）。',
  'intelligence.statusPending': '待機列',
  'intelligence.statusProcessing': '検索中',
  'intelligence.statusCompleted': '完了',
  'intelligence.statusNotFound': '見つかりません',
  'intelligence.statusFailed': '結果を取得できませんでした',
  'intelligence.errorQuota': '今日の検索をすべて使い切りました。また明日どうぞ。',
  'intelligence.errorPending': 'その検索はすでに進行中です。',
  'intelligence.errorNoRegion': '有効なサーバーを入力してください。',
  'intelligence.errorGeneric': '検索を完了できませんでした。もう一度お試しください。',
  'intelligence.search': '検索',
  'intelligence.resultsFound': '{count}件の結果',
  'intelligence.showMore': 'さらに{count}件表示',
  'intelligence.showLess': '折りたたむ',
  'intelligence.sortResults': '並べ替え',
  'intelligence.sortPower': '戦力',
  'intelligence.sortName': '名前',
  'intelligence.lastSeen': '確認',
  'intelligence.deleteConfirm': '「{name}」をパネルから削除しますか？検索は1日の上限にカウントされたままです。',
  // トークン経済 + マッピング進捗 (0.6.4, doc 17)
  'intelligence.tokensChip': 'トークン{n}枚',
  'intelligence.freeChip': '本日無料{n}回',
  'intelligence.freeTodayLabel': '本日の無料検索',
  'intelligence.tokensBalance': 'トークン残高',
  'intelligence.costsLine': 'トークン費用：検索 {search} · サーバー全体 {region}',
  'intelligence.noTokensCta': '無料検索もトークンも残っていません。設定でインテリジェンスマッピングを有効にすると、ボットがマップをスキャンしてトークンを獲得します。',
  'intelligence.errorTokens': 'この検索に必要なトークンが足りません。マッピングを有効にして獲得しましょう。',
  'intelligence.mappingTitle': 'マッピング進捗',
  'intelligence.mappingCells': '{total}マス中{scanned}マス',
  'intelligence.mappingToday': '本日ボットがスキャンしたマス',
  'intelligence.mappingEarnedToday': '本日獲得したトークン',
  'shieldWatch.toggle': 'プレイヤーのシールドを監視（このボットはマッピングを停止します）',
  'shieldWatch.title': 'Shield Monitor',
  'shieldWatch.historyTitle': '監視履歴',
  'activity.title': '情報アクティビティ',
  'activity.showAll': 'すべて表示（{count}）',
  'activity.showLess': '折りたたむ',
  'activity.protected': '攻撃を検知：シールドで保護しました',
  'activity.attackHalted': '攻撃を検知：シールド未確認',
  'shieldWatch.captureOpen': 'その瞬間のスクリーンショットを見る',
  'shieldWatch.captureLoading': 'スクリーンショットを読み込み中…',
  'shieldWatch.captureAlt': 'ボットが判断した瞬間のスクリーンショット',
  'shieldWatch.captureGone': 'このスクリーンショットはありません。ボットごとに直近5枚のみ保存します。',
  'shieldWatch.captureClose': '閉じる',
  'shieldWatch.help': '監視する城の座標を入力してください。ボットが定期的にシールドの有無を確認し、なくなったらメールでお知らせします。',
  'shieldWatch.interval': '間隔',
  'shieldWatch.region': 'リージョン',
  'shieldWatch.needCoords': '監視するプレイヤーのX・Y座標を入力してください。',
  'shieldWatch.idleNote': '確認はボットの空き時間に行われます。農作業が忙しいと間隔が空くことがあります。',
  'shieldWatch.stateShielded': '対象はまだシールドあり',
  'shieldWatch.stateConfirming': 'シールドなし：確認中…',
  'shieldWatch.stateDown': 'シールドが解除されました！',
  'shieldWatch.stateMoved': '対象はその座標にいません',
  'shieldWatch.stateNoDetector': '監視できません：検出器が利用不可',
  'intelligence.mappingNoRegion': '設定 → インテリジェンスマッピングでサーバーを選択・確認すると進捗が表示されます。',

  'support.title': 'サポート',
  'support.subtitle': 'カスタマーサポート — ここで直接お答えします。',
  'support.open': 'サポートチャットを開く',
  'support.close': 'サポートチャットを閉じる',
  'support.empty': 'お困りですか？問題を教えてください（スクリーンショット添付可）。このチャットでお答えします。',
  'support.placeholder': 'メッセージを入力…',
  'support.send': '送信',
  'support.sending': '送信中…',
  'support.attach': 'スクリーンショットを添付',
  'support.attachRemove': '画像を削除',
  'support.attachTooBig': '画像が5MBを超えています。',
  'support.attachNotImage': '添付できるのは画像のみです。',
  'support.imageAlt': '添付されたスクリーンショット',
  'support.you': 'あなた',
  'support.agent': 'サポート',
  'support.sendError': 'メッセージを送信できませんでした。もう一度お試しください。',
  'support.loading': '会話を読み込み中…',
  'support.unreadLabel': '新しいサポートメッセージ{count}件'
};

export const tr: Record<TranslationKey, string> = {
  'app.account': 'Hesap',
  'app.configuration': 'Ayarlar',
  'app.configurationUnavailable': 'Ayarlar kullanılamıyor',
  'app.faq': 'SSS',
  'app.faqButton': 'Sıkça sorulan sorular',
  'app.guide': 'Rehber',
  'app.guideButton': 'Kurulum rehberini görüntüle',
  'app.language': 'Dil',
  'app.license': 'Lisans',
  'app.manageBilling': 'Aboneliği yönet',
  'app.subscribe': 'Abone ol',
  'app.openAccountMenu': 'Hesap menüsünü aç',
  'app.signOut': 'Çıkış yap',
  'app.billingError': 'Ödeme portalı açılamadı.',
  'app.billingNoStripe': 'Lisansınız Stripe üzerinden yönetilmiyor (erişim manuel verildi): yönetilecek ödeme yok.',
  'app.product': 'White Bot Desktop',

  'auth.title': 'White Bot',
  'auth.subtitle': 'Desktop planı · Aylık €11,99 · 5 gün ücretsiz deneme',
  'auth.betaSubtitle': 'Ücretsiz beta',
  'auth.intro': 'Botunuzu yönetmek için giriş yapın.',
  'auth.email': 'E-posta',
  'auth.placeholderEmail': 'sen@eposta.com',
  'auth.sendLink': 'Giriş bağlantısı gönder',
  'auth.googleLogin': 'Google ile giriş yap',
  'auth.checkEmail': 'E-postanızı kontrol edin: size bir giriş bağlantısı gönderdik.',
  'auth.loadingSession': 'Oturum yükleniyor…',

  'entitlement.checking': 'Abonelik kontrol ediliyor…',
  'entitlement.active': 'aktif',
  'entitlement.trialing': 'deneme',
  'entitlement.past_due': 'ödeme bekleniyor',
  'entitlement.canceled': 'iptal edildi',
  'entitlement.inactive': 'pasif',

  'pills.connected': 'istemci bağlı',
  'pills.disconnected': 'istemci bağlı değil',

  'dashboard.actions': 'Eylemler',
  'dashboard.autoBot': 'Oto Bot',
  'dashboard.collect': 'Kaynak topla',
  'dashboard.trainTroops': 'Asker eğit',
  'dashboard.autoHunt': 'Oto Av',
  'dashboard.stopBot': 'Botu durdur',
  'dashboard.screenshot': 'Ekran görüntüsü',
  'dashboard.mockView': 'Simülasyon görünümü — istemci henüz görüntü göndermedi',
  'dashboard.marches': 'Yürüyüşler',
  'dashboard.training': 'Eğitim',
  'dashboard.noRecentVerification': 'Yakın zamanda kontrol yok',
  'dashboard.queue': 'Sıra',
  'dashboard.state': 'Durum',
  'dashboard.activity': 'Etkinlik',
  'dashboard.lastReport': 'Son rapor',
  'dashboard.clientVersion': 'İstemci sürümü',
  'dashboard.never': 'hiç',
  'dashboard.disconnectedNotice': 'İstemci bir süredir rapor göndermiyor. PC\'nizde BlueStacks ile birlikte açık olduğundan emin olun.',
  'dashboard.settingsSaved': 'Ayarlar kaydedildi.',
  'dashboard.client': 'İstemci',
  'dashboard.clientBody': 'İstemciyi PC\'nize indirip kurun (Windows + BlueStacks). Hesabınızla etkinleşir.',
  'dashboard.clientDownload': 'İstemciyi indir (tam sürümde)',
  'dashboard.clientDownloadReady': 'İstemciyi indir (beta)',
  'dashboard.clientSmartscreen': 'ZIP olarak iner: arşivi açıp kurulumu çalıştırın. İmzasız beta: tarayıcı veya Windows uyarırsa "Koru" ve "Daha fazla bilgi → Yine de çalıştır" seçin.',

  'op.workingEyebrow': 'İşlem sürüyor',
  'op.successEyebrow': 'Tamamlandı',
  'op.errorEyebrow': 'Onay yok',
  'op.warningEyebrow': 'Dikkat',
  'op.startTitle': '{action} başlatılıyor',
  'op.startBody': 'Komut gönderildi. PC\'nizdeki istemci birkaç saniye içinde alacak.',
  'op.stopTitle': 'Bot durduruluyor',
  'op.stopBody': 'Komut gönderildi. Bot mevcut adımı bitirip duracak.',
  'op.successStartTitle': 'Bot çalışıyor',
  'op.successStartBody': 'İstemci çalıştığını onayladı.',
  'op.successStopTitle': 'Bot durdu',
  'op.successStopBody': 'İstemci durmayı onayladı.',
  'op.timeoutTitle': 'İstemci onaylamadı',
  'op.timeoutBody': 'Komut kaydedildi ve istemci bağlanınca uygulanacak. İstemcinin PC\'nizde açık olduğunu kontrol edin.',
  'op.disconnectedTitle': 'İstemci bağlı değil',
  'op.disconnectedBody': 'Botunuz şu anda rapor göndermiyor. PC\'nizde istemciyi (BlueStacks ile birlikte) açın ve tekrar deneyin. Komutu yine de gönderebilirsiniz.',
  'op.sendAnyway': 'Yine de gönder',
  'op.close': 'Kapat',
  'op.cancel': 'İptal',

  'settings.level': 'Seviye',
  'settings.marches': 'Yürüyüşler',
  'settings.amount': 'Parti başına miktar',
  'settings.type': 'Tür',
  'settings.beasts': 'Canavarlar (10 enerji)',
  'settings.terror': 'Kutup Dehşeti (25 enerji)',
  'settings.timer': 'Toplanma bekleme',
  'settings.up': 'Artır',
  'settings.down': 'Azalt',
  'settings.resources.iron': 'Demir',
  'settings.resources.coal': 'Kömür',
  'settings.resources.wood': 'Odun',
  'settings.resources.meat': 'Et',
  'settings.units.infantry': 'Piyade',
  'settings.units.lancer': 'Mızrakçı',
  'settings.units.marksman': 'Nişancı',
  'settings.autoHelp': 'Oto Yardım',
  'settings.autoHeal': 'Oto İyileştirme',
  'settings.autoShield': 'Oto Kalkan',
  'settings.tasks': 'Görevler',
  'settings.tasksEnable': 'Otomatik görevleri etkinleştir',
  'settings.tasksHint': 'Günlük ödüller ve görevler: posta, ücretsiz kahramanlar, boşta sandığı ve istihbarat görevleri. Otomatik yapılır.',
  'settings.taskMail': 'Posta (al)',
  'settings.taskHeroes': 'Ücretsiz kahramanlar',
  'settings.taskIdle': 'Boşta sandığı',
  'settings.taskIntel': 'İstihbarat görevleri',
  // İstihbarat haritalama (0.6.4, doc 17)
  'settings.intelMapping': 'İstihbarat haritalama',
  'settings.intelEnable': 'İstihbarat haritalamayı etkinleştir',
  'settings.intelHint': 'Botlarınız seçilen bölgenin haritasını tarar ve İstihbarat ağını besler. Taranan her hücre, aramalarda kullanabileceğiniz jeton kazandırır.',
  'settings.intelRegion': 'Haritalanacak bölge',
  'settings.intelRegionHint': '3-5 basamak (örn. 4347). Genellikle kendi bölgeniz.',
  'settings.intelCheckRegion': 'Bölgeyi kontrol et',
  'settings.intelChecking': 'Bölge kontrol ediliyor…',
  'settings.intelRegionReady': '{region} bölgesi zaten ağda ({total} hücre). Haritalamaya hazır.',
  'settings.intelRegionSeeded': '{region} bölgesi ağa eklendi ({total} hücre). Botlarınız haritalamaya başlayabilir.',
  'settings.intelRegionInvalid': 'Geçersiz bölge: 3-5 basamak kullanın.',
  'settings.intelRegionError': 'Bölge kontrol edilemedi. Lütfen tekrar deneyin.',
  'settings.intelCellsPerPass': 'Tur başına hücre',
  'settings.intelCellsPerPassHint': 'Botun diğer görevlere dönmeden önce her haritalama turunda kaç hücre tarayacağı.',
  'settings.game': 'Oyun',
  'settings.gameLanguage': 'Oyun dili',
  'settings.gameLanguageEn': 'İngilizce (varsayılan)',
  'settings.gameLanguageEs': 'İspanyolca',
  'settings.gameLanguageHint': 'Bu, BlueStacks içindeki OYUNUN dilidir (bu sitenin değil). Bot oyunu yalnızca İngilizce veya İspanyolca okuyabilir: oyunun Ayarlar → Dil bölümünden ayarlayın ve burada aynısını seçin.',
  'settings.cryptids': 'Önce kriptidler (etkinlik)',
  'settings.cryptidsHint': 'Çılgın Kriptid etkinliği aktifken ve Kriptid Boynuzunuz varsa av bunu bir kriptide harcar; etkinlik veya boynuz yoksa her zamanki gibi avlanır (canavar öldürmek boynuz düşürür).',
  'status.hunting_cryptid': 'Etkinlik kriptidi aranıyor…',

  'subscribe.title': 'White Bot\'u 5 gün ücretsiz dene',
  'subscribe.body': 'White Bot\'u kendi PC\'nizde çalıştırın (Windows + BlueStacks) ve bu siteden kontrol edin.',
  'subscribe.trial': 'DENEME',
  'subscribe.trialValue': '5 gün ücretsiz',
  'subscribe.after': 'SONRASI',
  'subscribe.afterValue': 'Aylık €11,99',
  'subscribe.includes': 'İÇERİK',
  'subscribe.includesValue': 'Toplama · Asker · Av · İyileştirme · Kalkan · İttifak yardımı · Günlük görevler',
  'subscribe.cancel': 'İPTAL',
  'subscribe.cancelValue': 'İstediğiniz zaman',
  'subscribe.cta': 'Ücretsiz denemeyi başlat (5 gün)',
  'subscribe.ctaOpening': 'Ödeme açılıyor…',
  'subscribe.cardNote': 'Deneme için kart gerekmez. Yalnızca deneme bitince abone olmaya karar verirseniz ödersiniz.',
  'subscribe.trialCta': '5 günlük ücretsiz denemeyi başlat — kartsız',
  'subscribe.trialStarting': 'Deneme etkinleştiriliyor…',
  'subscribe.trialError': 'Deneme etkinleştirilemedi. Lütfen tekrar deneyin.',
  'subscribe.trialUsed': 'Bu hesapta ücretsiz deneme zaten kullanıldı.',
  'subscribe.payCta': 'Abone ol — Aylık €11,99',
  'subscribe.endedTitle': 'Erişiminiz sona erdi',
  'subscribe.endedBody': 'Denemeniz veya aboneliğiniz sona erdi. PC\'nizde White Bot kullanmaya devam etmek için abone olun — ayarlarınız korunur.',
  'subscribe.checkoutError': 'Ödeme başlatılırken hata',
  'subscribe.hostedNote': 'Barındırılan hizmeti mi (bizim sunucularımızda çalışır) kullanıyorsunuz? O ayrı bir ürün:',
  'subscribe.hostedLink': 'whitebot.app\'e git',

  'beta.banner': 'Ücretsiz beta',
  'subscribe.betaTitle': 'Beta süresince ücretsiz White Bot',
  'subscribe.betaTrial': 'BETA',
  'subscribe.betaTrialValue': '15 Ağu 2026\'ya kadar ücretsiz',
  'subscribe.betaTrialCta': 'Ücretsiz betayı başlat',
  'subscribe.betaCardNote': 'Kart gerekmez. White Bot beta süresince, 15 Ağustos 2026\'ya kadar ücretsizdir.',
  'subscribe.betaEndedNote': 'Ücretsiz betadayız. Erişiminiz yoksa destek sohbetinden bize yazın.',

  'tutorial.title': 'İlk adımlar',
  'tutorial.intro': 'Botunuzu PC\'nizde çalıştırıp buradan kontrol etmek için üç adım.',
  'tutorial.step1Title': '1. İstemciyi kurun',
  'tutorial.step1Body': 'İstemciyi indirin ve BlueStacks ile birlikte PC\'nize kurun. Rehber adım adım yol gösterir.',
  'tutorial.step2Title': '2. E-postanızla etkinleştirin',
  'tutorial.step2Body': 'İstemciyi açın ve e-postanızı girin. Bağlandığında burada "istemci bağlı" göreceksiniz.',
  'tutorial.step3Title': '3. Botu buradan kontrol edin',
  'tutorial.step3Body': 'Modülleri ve ayarları seçin, bir eyleme basın; görüntüyü ve durumu bu panelden izleyin.',
  'tutorial.dontShowAgain': 'Bir daha gösterme',
  'tutorial.notNow': 'Şimdi değil',
  'tutorial.gotIt': 'Anladım',

  'pills.license': 'lisans: {label}',

  'dashboard.refreshCapture': 'Görüntüyü yenile',
  'dashboard.refreshCapturePending': 'Görüntü alınıyor…',
  'dashboard.refreshCaptureTimeout': 'İstemci görüntü isteğine yanıt vermedi. PC\'nizde açık olduğunu kontrol edin.',

  'state.idle': 'boşta',
  'state.running': 'çalışıyor',
  'state.waiting': 'bekliyor',
  'state.starting': 'başlatılıyor',
  'state.verifying': 'kontrol ediyor',
  'state.training': 'eğitiyor',
  'state.collecting': 'topluyor',
  'state.hunting': 'avlanıyor',
  'state.helping': 'yardım ediyor',
  'state.healing': 'iyileştiriyor',
  'state.recovering': 'toparlanıyor',
  'state.reconnecting': 'yeniden bağlanıyor',
  'state.shielded': 'kalkan aktif',
  'state.error': 'hata',

  'status.no_client': 'Bağlı istemci yok.',
  'status.idle': 'Beklemede (web\'den durduruldu).',
  'status.running': 'Çalışıyor: {modules}',
  'status.running_none': 'Çalışıyor (aktif modül yok).',
  'status.shielded': 'Oto Kalkan korumayı devreye aldı: bot durdu. Devam etmek için Durdur\'a, sonra tekrar Başlat\'a basın.',
  'shieldAlarm.eyebrow': 'Oto Kalkan',
  'shieldAlarm.title': 'Seni bir saldırıdan koruduk',
  'shieldAlarm.body': "{name} üzerine bir saldırı tespit ettik ve kalkanını otomatik olarak devreye aldık. Birliklerin geri çağrıldı ve kolonin güvende. Bot güvenlik için durdu — devam etmek istediğinde Başlat'a bas.",
  'shieldAlarm.time': 'Saldırı zamanı',
  'shieldAlarm.close': 'Anladım',
  'status.starting': 'Başlangıç kontrolü: ekran temizleniyor ve şehir doğrulanıyor…',
  'status.waiting': 'Yapılacak bir şey yok. Sonraki kontrol: {time}.',
  'status.backoff_wait': 'Toparlanma sürüyor; {time} içinde yeniden denenecek.',
  'status.verifying_training': 'Eğitim sıraları kontrol ediliyor…',
  'status.verifying_marches': 'Yürüyüş sıraları kontrol ediliyor…',
  'status.verifying_hunt': 'Av yürüyüşleri kontrol ediliyor…',
  'status.training_collect': 'Tamamlanan askerler alınıyor: {units}',
  'langWarn.eyebrow': 'Oyun dili',
  'langWarn.title': 'Oyunu İngilizce yapın',
  'langWarn.body': "White Bot oyununuzu okuyamıyor: dil desteklenmiyor. Whiteout Survival'da Ayarlar → Language bölümünden English'i seçin. Değiştirdiğinizde bot kendiliğinden devam eder.",
  'langWarn.close': 'Anladım',
  'fleet.title': 'Botlarım',
  'fleet.counter': '{n}/{max} bot',
  'fleet.startAll': 'Tümünü başlat',
  'fleet.stopAll': 'Tümünü durdur',
  'fleet.delete': 'Sil',
  'fleet.deleteConfirmTitle': '{name} silinsin mi?',
  'fleet.deleteConfirmBody': 'Hesap limitinizden bir yer boşalır. O botun istemcisi PC\'nizde hâlâ açıksa, bir sonraki raporda yeniden görünür.',
  'fleet.deleteConfirm': 'Botu sil',
  'fleet.deleteCancel': 'İptal',
  'fleet.back': 'Tüm botlar',
  'fleet.empty': 'Henüz bot yok. PC\'nizde White Bot Client\'ı açın (her BlueStacks örneği için bir konsol), burada kendiliğinden görünürler.',
  'fleet.defaultName': 'Bot',
  'fleet.lastReport': 'Son rapor',
  'status.unsupported_language': 'Oyun dili desteklenmiyor — İngilizce yapın',
  'status.language_autofix': 'Desteklenmeyen dil: oyun otomatik olarak İngilizceye geçiriliyor…',
  'status.dailies': 'Günlük ödüller alınıyor…',
  'status.intel_missions': 'İstihbarat görevleri…',
  'status.intel_map_scanning': 'İstihbarat: {cells} hücre tarandı (+{tokens} jeton)',
  'status.intel_map_region_done': 'İstihbarat: bölge güncel',
  'status.intel_map_detector_missing': 'İstihbarat: dedektör kullanılamıyor',
  'status.intel_map_region_missing': 'İstihbarat: Ayarlar bölümünden bölgeyi ayarlayın',
  'state.intel': 'İstihbarat',
  'state.dailies': 'Günlük ödüller',
  'status.language_fixed': 'İngilizceye geçirildi; oyunun yeniden başlaması bekleniyor…',
  'state.fixing_language': 'Dil değiştiriliyor',
  'state.blocked_language': 'Desteklenmeyen dil',
  'status.training_units': 'Askerler eğitiliyor: {units} (%{percent})',
  'status.collecting_send': 'Toplama yürüyüşü gönderiliyor: {resource} (seviye {level})',
  'status.hunting_send': 'Av saldırısı gönderiliyor: {type} seviye {level}',
  'status.helping': 'İttifak Oto Yardım kontrol ediliyor…',
  'status.healing': 'Oto İyileştirme kontrol ediliyor…',
  'status.recovering_attempt': 'Toparlanıyor ({attempt}/{max}); {time} içinde tekrar…',
  'status.recovered_ui': 'Hatadan ({task}) sonra ekran düzeldi. Devam ediliyor…',
  'status.relaunching': 'Tekrarlanan hatalar nedeniyle BlueStacks/oyun yeniden başlatılıyor…',
  'status.relaunched': 'Hata sonrası oyun yeniden başlatıldı. {time} içinde devam edilecek.',
  'status.hand_guide': 'Eğitim eli algılandı: gösterdiği yere dokunuluyor…',
  'status.reconnecting': 'Oturum başka bir cihazda açıldı: Yeniden Bağlan\'a basılıyor…',
  'status.backoff_init_error': 'Başlatma hatası ({detail}). {time} içinde otomatik tekrar.',
  'status.backoff_no_adb': 'BlueStacks (ADB) bağlantısı yok. BlueStacks\'in açık olduğunu kontrol edin. {time} içinde tekrar.',
  'status.backoff_failure': 'Tekrarlanan hata ({task}). {time} içinde otomatik tekrar.',
  'status.backoff_blocked': 'Ekran engellendi ({kind}). {time} içinde otomatik tekrar.',

  'statusTask.verify_training': 'eğitim sırası kontrolü',
  'statusTask.collect_completed': 'tamamlanan asker alımı',
  'statusTask.train_flow': 'eğitim akışı',
  'statusTask.return_after_training': 'eğitim sonrası şehre dönüş',
  'statusTask.verify_marches': 'yürüyüş kontrolü',
  'statusTask.collect_flow': 'toplama akışı',
  'statusTask.hunt_capture': 'av durumu görüntüsü',
  'statusTask.verify_hunt': 'av yürüyüşü kontrolü',
  'statusTask.hunt_vigor': 'enerji okuma',
  'statusTask.hunt_flow': 'av akışı',
  'statusTask.auto_heal': 'oto iyileştirme',
  'statusTask.startup_return': 'başlangıçta şehre dönüş',
  'statusTask.startup_screen': 'başlangıçta tanınmayan ekran',
  'statusTask.unexpected': 'beklenmeyen hata',

  'intelligence.title': 'İstihbarat',
  'intelligence.intro': 'White Bot ağının topladığı oyuncu ve ittifakları arayın. Günde {limit} arama.',
  'intelligence.region': 'Bölge',
  'intelligence.regionPlaceholder': 'Bölge (örn. 4347)',
  'intelligence.searchPlayer': 'Oyuncu veya ittifak ara',
  'intelligence.searchPlaceholder': 'Oyuncu veya ittifak (boş = tüm bölge)',
  'intelligence.regionSearchTitle': 'Tüm bölge {region}',
  'intelligence.errorUnknownRegion': 'Bu bölge henüz ağda yok (numarayı kontrol edin).',
  'intelligence.quotaRemainingValue': '{limit} aramadan {remaining} kaldı',
  'intelligence.request': 'Ara',
  'intelligence.requesting': 'Aranıyor…',
  'intelligence.quotaRemaining': 'Bugün kalan arama',
  'intelligence.minChars': 'En az 3 karakter yazın veya tüm bölgeyi listelemek için boş bırakın.',
  'intelligence.regionRequired': 'Aranacak bölgeyi girin (örn. 4347).',
  'intelligence.loading': 'Aramalar yükleniyor…',
  'intelligence.empty': 'Henüz arama yok.',
  'intelligence.delete': 'Aramayı sil',
  'intelligence.power': 'Güç',
  'intelligence.coordinates': 'Koordinatlar',
  'intelligence.notFound': 'Eşleşme yok.',
  'intelligence.noResult': 'Sonuç bekleniyor (bu bölgede henüz veri yok).',
  'intelligence.statusPending': 'Sırada',
  'intelligence.statusProcessing': 'Aranıyor',
  'intelligence.statusCompleted': 'Tamamlandı',
  'intelligence.statusNotFound': 'Bulunamadı',
  'intelligence.statusFailed': 'Sonuç alınamadı',
  'intelligence.errorQuota': 'Bugünkü aramalarınızı kullandınız. Yarın tekrar gelin.',
  'intelligence.errorPending': 'Bu arama zaten sürüyor.',
  'intelligence.errorNoRegion': 'Geçerli bir bölge girin.',
  'intelligence.errorGeneric': 'Arama tamamlanamadı. Lütfen tekrar deneyin.',
  'intelligence.search': 'Ara',
  'intelligence.resultsFound': '{count} sonuç',
  'intelligence.showMore': '{count} tane daha göster',
  'intelligence.showLess': 'Daha az göster',
  'intelligence.sortResults': 'Sırala',
  'intelligence.sortPower': 'Güç',
  'intelligence.sortName': 'İsim',
  'intelligence.lastSeen': 'Görülme',
  'intelligence.deleteConfirm': '"{name}" panelden kaldırılsın mı? Arama yine de günlük limite sayılır.',
  // Jeton ekonomisi + haritalama ilerlemesi (0.6.4, doc 17)
  'intelligence.tokensChip': '{n} jeton',
  'intelligence.freeChip': 'Bugün {n} ücretsiz',
  'intelligence.freeTodayLabel': 'Bugünün ücretsiz araması',
  'intelligence.tokensBalance': 'Jeton bakiyesi',
  'intelligence.costsLine': 'Jeton maliyeti: arama {search} · tüm bölge {region}',
  'intelligence.noTokensCta': 'Ücretsiz arama ve jeton kalmadı: Ayarlar bölümünden istihbarat haritalamayı etkinleştirin, botlarınız haritayı tarayarak jeton kazansın.',
  'intelligence.errorTokens': 'Bu arama için yeterli jeton yok. Daha fazla kazanmak için haritalamayı etkinleştirin.',
  'intelligence.mappingTitle': 'Haritalama ilerlemesi',
  'intelligence.mappingCells': '{total} hücreden {scanned} tarandı',
  'intelligence.mappingToday': 'Bugün botlarınızın taradığı hücreler',
  'intelligence.mappingEarnedToday': 'Bugün kazanılan jeton',
  'shieldWatch.toggle': 'Bir oyuncunun kalkanını izle (bu bot haritalamayı bırakır)',
  'shieldWatch.title': 'Shield Monitor',
  'shieldWatch.historyTitle': 'İzleme geçmişi',
  'activity.title': 'İstihbarat etkinliği',
  'activity.showAll': 'Tümünü göster ({count})',
  'activity.showLess': 'Daha az göster',
  'activity.protected': 'Saldırı algılandı: seni kalkanla koruduk',
  'activity.attackHalted': 'Saldırı algılandı: kalkan DOĞRULANMADI',
  'shieldWatch.captureOpen': 'O anın ekran görüntüsünü gör',
  'shieldWatch.captureLoading': 'Ekran görüntüsü yükleniyor…',
  'shieldWatch.captureAlt': 'Botun karar verdiği andaki ekran görüntüsü',
  'shieldWatch.captureGone': 'Bu ekran görüntüsü yok: her bot için yalnızca son 5 tanesi saklanır.',
  'shieldWatch.captureClose': 'Kapat',
  'shieldWatch.help': 'İzlenecek kalenin koordinatlarını gir. Bot düzenli olarak kalkanının durup durmadığını kontrol eder ve düştüğünde sana e-posta gönderir.',
  'shieldWatch.interval': 'Her',
  'shieldWatch.region': 'Bölge',
  'shieldWatch.needCoords': 'İzlenecek oyuncunun X ve Y koordinatlarını gir.',
  'shieldWatch.idleNote': 'Kontroller botun boş zamanlarında yapılır; çiftlik yoğunsa aralıklar açılabilir.',
  'shieldWatch.stateShielded': 'Hedefin kalkanı HÂLÂ duruyor',
  'shieldWatch.stateConfirming': 'Kalkan yok: doğrulanıyor…',
  'shieldWatch.stateDown': 'KALKAN DÜŞTÜ!',
  'shieldWatch.stateMoved': 'Hedef artık bu koordinatlarda değil',
  'shieldWatch.stateNoDetector': 'İzlenemiyor: dedektör kullanılamıyor',
  'intelligence.mappingNoRegion': 'İlerlemeyi görmek için Ayarlar → İstihbarat haritalama bölümünden bir bölge seçip kontrol edin.',

  'support.title': 'Destek',
  'support.subtitle': 'Müşteri desteği — tam burada yanıtlıyoruz.',
  'support.open': 'Destek sohbetini aç',
  'support.close': 'Destek sohbetini kapat',
  'support.empty': 'Yardım mı lazım? Sorunu anlatın (ekran görüntüsü ekleyebilirsiniz), bu sohbette yanıtlayacağız.',
  'support.placeholder': 'Mesajınızı yazın…',
  'support.send': 'Gönder',
  'support.sending': 'Gönderiliyor…',
  'support.attach': 'Ekran görüntüsü ekle',
  'support.attachRemove': 'Görseli kaldır',
  'support.attachTooBig': 'Görsel 5 MB\'tan büyük.',
  'support.attachNotImage': 'Yalnızca görsel eklenebilir.',
  'support.imageAlt': 'Eklenen ekran görüntüsü',
  'support.you': 'Siz',
  'support.agent': 'Destek',
  'support.sendError': 'Mesaj gönderilemedi. Lütfen tekrar deneyin.',
  'support.loading': 'Konuşma yükleniyor…',
  'support.unreadLabel': '{count} yeni destek mesajı'
};
